(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-section-type="announcement-bar"]');
    if (!bar) return;

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-close-announcement]');
      if (!btn) return;

      var scope = btn.getAttribute('data-close-announcement');
      if (scope === 'row') {
        var item = btn.closest('.announcement-bar__item');
        if (item) item.remove();
        var remaining = bar.querySelectorAll('.announcement-bar__item');
        if (remaining.length === 0) {
          bar.remove();
        }
      } else {
        bar.remove();
      }

      document.documentElement.style.setProperty('--f-announcement-height', '0px');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collapsible-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collapsible-tab')) {
    class CollapsibleTab extends HTMLElement {
      constructor() {
        super();
        this.trigger = null;
        this.content = null;
      }

      connectedCallback() {
        this.trigger = this.querySelector('[data-trigger]');
        this.content = this.querySelector('[data-content]');

        if (!this.trigger || !this.content) return;

        this.trigger.addEventListener('click', () => this.toggle());

        if (this.getAttribute('open') === 'true') {
          this.expand(false);
        }
      }

      toggle() {
        if (this.getAttribute('open') === 'true') {
          this.collapse();
        } else {
          this.expand(true);
        }
      }

      expand(animate) {
        this.setAttribute('open', 'true');
        this.content.removeAttribute('hidden');

        if (animate) {
          this.content.style.height = '0';
          this.content.style.overflow = 'hidden';
          requestAnimationFrame(() => {
            this.content.style.height = this.content.scrollHeight + 'px';
            this.content.addEventListener(
              'transitionend',
              () => {
                this.content.style.height = '';
                this.content.style.overflow = '';
              },
              { once: true }
            );
          });
        }
      }

      collapse() {
        this.setAttribute('open', 'false');
        this.content.style.height = this.content.scrollHeight + 'px';
        this.content.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          this.content.style.height = '0';
          this.content.addEventListener(
            'transitionend',
            () => {
              this.content.setAttribute('hidden', '');
              this.content.style.height = '';
              this.content.style.overflow = '';
            },
            { once: true }
          );
        });
      }
    }

    customElements.define('collapsible-tab', CollapsibleTab);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo-content"]) return;
  try {
    
  (function () {
    var MAX_LINES = 3;
    var bodyEl = document.querySelector('.collection-seo-content__body');
    if (!bodyEl) return;

    var readMoreLabel = bodyEl.getAttribute('data-read-more-label') || 'read more';
    var readLessLabel = bodyEl.getAttribute('data-read-less-label') || 'read less';
    var originalHTML = bodyEl.innerHTML;

    function getMaxHeight() {
      var computed = window.getComputedStyle(bodyEl);
      var lh = parseFloat(computed.lineHeight);
      if (isNaN(lh)) lh = parseFloat(computed.fontSize) * 1.3;
      return Math.ceil(lh * MAX_LINES);
    }

    function needsTruncation() {
      return bodyEl.scrollHeight > getMaxHeight() + 2;
    }

    function createToggle(label, onClick) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'collection-seo-content__toggle';
      btn.textContent = label;
      btn.addEventListener('click', onClick);
      return btn;
    }

    function buildTruncatedFragment(maxHeight) {
      var measurer = document.createElement('div');
      var cs = window.getComputedStyle(bodyEl);
      measurer.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;';
      measurer.style.width = bodyEl.offsetWidth + 'px';
      measurer.style.font = cs.font;
      measurer.style.letterSpacing = cs.letterSpacing;
      measurer.style.lineHeight = cs.lineHeight;
      measurer.innerHTML = originalHTML;
      document.body.appendChild(measurer);

      var textNodes = [];
      var walker = document.createTreeWalker(measurer, NodeFilter.SHOW_TEXT, null, false);
      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      var suffix = '\u2026' + readMoreLabel;

      for (var i = textNodes.length - 1; i >= 0; i--) {
        var node = textNodes[i];
        var origText = node.textContent;

        for (var j = i + 1; j < textNodes.length; j++) {
          textNodes[j].textContent = '';
        }

        var low = 0;
        var high = origText.length;

        var suffixSpan = document.createElement('span');
        suffixSpan.style.cssText = 'display:inline;';
        suffixSpan.textContent = suffix;
        node.parentNode.insertBefore(suffixSpan, node.nextSibling);

        while (low < high) {
          var mid = Math.ceil((low + high) / 2);
          node.textContent = origText.substring(0, mid);
          if (measurer.scrollHeight <= maxHeight + 2) {
            low = mid;
          } else {
            high = mid - 1;
          }
        }

        suffixSpan.remove();

        if (low > 0) {
          node.textContent = origText.substring(0, low);
          removeNodesAfter(node, measurer);
          document.body.removeChild(measurer);
          return measurer;
        }

        node.textContent = '';
      }

      document.body.removeChild(measurer);
      measurer.innerHTML = originalHTML;
      return measurer;
    }

    function removeNodesAfter(node, root) {
      var current = node;
      while (current && current !== root) {
        while (current.nextSibling) {
          current.parentNode.removeChild(current.nextSibling);
        }
        current = current.parentNode;
      }
    }

    function getLastTextNode(el) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var last = null;
      while (walker.nextNode()) {
        last = walker.currentNode;
      }
      return last;
    }

    function render(expanded) {
      if (expanded) {
        bodyEl.innerHTML = originalHTML;
        var lastText = getLastTextNode(bodyEl);
        var appendTo = lastText ? lastText.parentNode : (bodyEl.lastElementChild || bodyEl);
        appendTo.appendChild(document.createTextNode(' '));
        appendTo.appendChild(createToggle(readLessLabel, function () {
          render(false);
        }));
      } else {
        var fragment = buildTruncatedFragment(getMaxHeight());

        bodyEl.innerHTML = '';
        while (fragment.firstChild) {
          bodyEl.appendChild(fragment.firstChild);
        }

        var lastText = getLastTextNode(bodyEl);
        var appendTo = lastText ? lastText.parentNode : (bodyEl.lastElementChild || bodyEl);
        appendTo.appendChild(document.createTextNode('\u2026'));
        appendTo.appendChild(createToggle(readMoreLabel, function () {
          render(true);
        }));
      }
    }

    if (needsTruncation()) {
      render(false);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        bodyEl.innerHTML = originalHTML;
        if (needsTruncation()) {
          render(false);
        }
      }, 150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSection(section) {
    var slider = section.querySelector('[data-fb-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;

    if (slider._fbSliderInit) {
      slider._fbSliderUpdate();
      return;
    }

    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dotsContainer = section.querySelector('[data-slider-dots]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 4;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (slideWidth === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap));
      if (slidesPerView === 0) slidesPerView = 1;
      var totalDots = Math.ceil(slides.length / slidesPerView);

      if (totalDots <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'fb__dot' + (i === 0 ? ' fb__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.dataset.dotIndex = i;
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.dotIndex);
          var spv = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
          var scrollTarget = idx * spv * (slideWidth + gap);
          slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.fb__dot');
      if (dots.length === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
      var currentGroup = Math.round(slider.scrollLeft / (slidesPerView * (slideWidth + gap)));

      dots.forEach(function(dot, i) {
        dot.classList.toggle('fb__dot--active', i === currentGroup);
      });
    }

    function update() {
      measure();
      updateNavState();
      createDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateNavState();
        updateDots();
      }, 50);
    });

    var resizeObserver = new ResizeObserver(function() {
      update();
    });
    resizeObserver.observe(slider);

    slider._fbSliderInit = true;
    slider._fbSliderUpdate = update;
    update();
  }

  document.querySelectorAll('.featured-blog-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.featured-blog-section');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product-slider"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initFPS(section) {
    var slider = section.querySelector('[data-slider-track]');
    var slides = slider ? slider.querySelectorAll('[data-slide]') : [];
    var totalSlides = slides.length;

    if (!slider || totalSlides <= 1) return;

    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dots = section.querySelectorAll('[data-dot-index]');

    var currentIndex = 0;
    var slideWidth = 0;
    var gap = 0;
    var autoplayInterval = null;
    var autoplaySpeed = section.dataset.autoplay ? parseInt(section.dataset.autoplay) * 1000 : 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
    }

    function goTo(idx) {
      if (idx < 0) idx = 0;
      if (idx >= totalSlides) idx = totalSlides - 1;
      currentIndex = idx;

      var targetLeft = slides[idx] ? slides[idx].offsetLeft : 0;
      slider.scrollTo({ left: targetLeft, behavior: 'smooth' });

      dots.forEach(function(dot, i) {
        dot.classList.toggle('fps__dot--active', i === idx);
      });

      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= totalSlides - 1;
    }

    function nextSlide() {
      if (currentIndex < totalSlides - 1) {
        goTo(currentIndex + 1);
      } else {
        goTo(0);
      }
    }

    function startAutoplay() {
      if (!autoplaySpeed) return;
      stopAutoplay();
      autoplayInterval = setInterval(nextSlide, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayInterval) {
        clearInterval(autoplayInterval);
        autoplayInterval = null;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        goTo(currentIndex - 1);
        stopAutoplay();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        goTo(currentIndex + 1);
        stopAutoplay();
        startAutoplay();
      });
    }

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(dot.dataset.dotIndex, 10));
        stopAutoplay();
        startAutoplay();
      });
    });

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        measure();
        if (slideWidth === 0) return;
        var scrollLeft = slider.scrollLeft;
        var newIdx = 0;
        for (var i = 0; i < totalSlides; i++) {
          if (slides[i].offsetLeft <= scrollLeft + slideWidth / 2) {
            newIdx = i;
          }
        }
        if (newIdx !== currentIndex) {
          goTo(newIdx);
        }
      }, 80);
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    var resizeObs = new ResizeObserver(function() { measure(); });
    resizeObs.observe(slider);

    measure();
    goTo(0);
    startAutoplay();

    document.addEventListener('shopify:block:select', function(e) {
      var closest = e.target.closest('[data-section-type="featured-product-slider"]');
      if (closest === section) {
        var slide = e.target.closest('[data-slide]');
        if (slide) {
          var idx = Array.prototype.indexOf.call(slides, slide);
          if (idx >= 0) {
            stopAutoplay();
            goTo(idx);
          }
        }
      }
    });
  }

  document.querySelectorAll('[data-section-type="featured-product-slider"]').forEach(initFPS);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-section-type="featured-product-slider"]');
    if (section) initFPS(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  /* --- Product Modal (Zoom) --- */
  class ProductModal extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.product-zoom__item'));
      this.closeButton = this.querySelector('[id^="ModalClose"]');
      this.prevButton = this.querySelector('[data-zoom-prev]');
      this.nextButton = this.querySelector('[data-zoom-next]');

      if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.navigate(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.navigate(1));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });

      this.querySelectorAll('[data-zoom-wrapper]').forEach((wrapper) => {
        wrapper.addEventListener('click', (e) => {
          if (wrapper._wasDragged) {
            wrapper._wasDragged = false;
            return;
          }
          this.toggleZoom(wrapper, e);
        });
      });
    }

    open(mediaId) {
      this.removeAttribute('hidden');
      this.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';

      var targetIndex = 0;
      if (mediaId) {
        this.items.forEach(function(item, i) {
          if (item.dataset.mediaId === String(mediaId)) targetIndex = i;
        });
      }

      this.showItem(targetIndex);
      this.focus();
    }

    close() {
      this.setAttribute('hidden', '');
      this.removeAttribute('open');
      document.documentElement.style.overflow = '';
      this.resetZoom();
    }

    resetZoom() {
      var self = this;
      this.querySelectorAll('.is-zoomed').forEach(function(el) {
        el.classList.remove('is-zoomed');
        var img = el.querySelector('.product-zoom__image');
        if (img) img.style.transform = '';
        self.cleanupDrag(el);
      });
    }

    showItem(index) {
      if (index < 0) index = this.items.length - 1;
      if (index >= this.items.length) index = 0;
      this.currentIndex = index;

      this.items.forEach(function(item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    navigate(direction) {
      this.resetZoom();
      this.showItem(this.currentIndex + direction);
    }

    toggleZoom(wrapper, event) {
      var img = wrapper.querySelector('.product-zoom__image');
      if (!img) return;

      var isZoomed = wrapper.classList.contains('is-zoomed');
      if (isZoomed) {
        wrapper.classList.remove('is-zoomed');
        img.style.transform = '';
        this.cleanupDrag(wrapper);
      } else {
        var preRect = wrapper.getBoundingClientRect();
        var clickX = (event.clientX - preRect.left) / preRect.width;
        var clickY = (event.clientY - preRect.top) / preRect.height;

        wrapper.classList.add('is-zoomed');

        /* Get wrapper and actual image dimensions after layout change */
        var rect = wrapper.getBoundingClientRect();
        var imgW = img.offsetWidth || rect.width;
        var imgH = img.offsetHeight || rect.height;

        var scale = 1.8;
        var tx = -(clickX * imgW * (scale - 1));
        var ty = -(clickY * imgH * (scale - 1));

        /* Clamp so image doesn't go past edges */
        tx = Math.min(0, Math.max(tx, rect.width - imgW * scale));
        ty = Math.min(0, Math.max(ty, rect.height - imgH * scale));

        img.style.transform = 'scale(' + scale + ') translate(' + (tx / scale) + 'px, ' + (ty / scale) + 'px)';

        this.setupDrag(wrapper, img, scale, rect.width, rect.height, imgW, imgH);
      }
    }

    setupDrag(wrapper, img, scale, wrapW, wrapH, imgW, imgH) {
      var startX, startY, currentTx, currentTy;
      var isDragging = false;

      function getTranslate() {
        var t = img.style.transform;
        var match = t.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
        if (match) {
          return { x: parseFloat(match[1]) * scale, y: parseFloat(match[2]) * scale };
        }
        return { x: 0, y: 0 };
      }

      function clamp(val, min, max) {
        return Math.min(max, Math.max(min, val));
      }

      function onPointerDown(e) {
        if (!wrapper.classList.contains('is-zoomed')) return;
        e.preventDefault();
        isDragging = true;
        wrapper.classList.add('is-dragging');
        startX = e.clientX;
        startY = e.clientY;
        var t = getTranslate();
        currentTx = t.x;
        currentTy = t.y;
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        var newTx = clamp(currentTx + dx, wrapW - imgW * scale, 0);
        var newTy = clamp(currentTy + dy, wrapH - imgH * scale, 0);
        img.style.transform = 'scale(' + scale + ') translate(' + (newTx / scale) + 'px, ' + (newTy / scale) + 'px)';
      }

      function onPointerUp(e) {
        if (!isDragging) return;
        isDragging = false;
        wrapper.classList.remove('is-dragging');
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if (dx >= 5 || dy >= 5) {
          wrapper._wasDragged = true;
        }
      }

      wrapper.addEventListener('pointerdown', onPointerDown, { passive: false });
      document.addEventListener('pointermove', onPointerMove, { passive: false });
      document.addEventListener('pointerup', onPointerUp);

      wrapper._dragCleanup = function() {
        wrapper.removeEventListener('pointerdown', onPointerDown);
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        wrapper.classList.remove('is-dragging');
        delete wrapper._dragCleanup;
      };
    }

    cleanupDrag(wrapper) {
      if (wrapper._dragCleanup) wrapper._dragCleanup();
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  /* --- Media Gallery (zoom delegation) --- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', function(e) {
        var btn = e.target.closest('.js-product-zoom');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var mediaId = btn.dataset.mediaId;
        var sectionId = this.dataset.sectionId;
        var modal = document.getElementById('ProductModal-' + sectionId);
        if (modal && modal.open) {
          modal.open(mediaId);
        }
      });
    }
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }

  /* --- Flickity Component (Lightweight Carousel) --- */
  class FlickityComponent extends HTMLElement {
    connectedCallback() {
      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      if (this.cells.length < 2) return;

      this.currentIndex = 0;
      this.options = this.getOptions();
      this.isResponsive = this.classList.contains('md:flickity-disable');
      this.isEnabled = this.dataset.enableSlider === 'true';

      if (this.isResponsive) {
        this.mediaQuery = window.matchMedia('(min-width: 1025px)');
        this.handleResize = () => this.onResize();
        this.mediaQuery.addEventListener('change', this.handleResize);
        this.onResize();
      } else if (this.isEnabled) {
        this.setupCarousel();
      }

    }

    disconnectedCallback() {
      if (this.mediaQuery && this.handleResize) {
        this.mediaQuery.removeEventListener('change', this.handleResize);
      }
    }

    onResize() {
      if (this.mediaQuery.matches) {
        this.destroyCarousel();
      } else {
        if (!this.isCarouselActive) {
          this.setupCarousel();
        }
      }
    }

    getCellSelector() {
      try {
        var opts = JSON.parse(this.dataset.sliderOptions || '{}');
        return opts.cellSelector || ':scope > *';
      } catch (e) {
        return ':scope > *';
      }
    }

    getOptions() {
      try {
        return JSON.parse(this.dataset.sliderOptions || '{}');
      } catch (e) {
        return {};
      }
    }

    setupCarousel() {
      if (this.isCarouselActive) return;
      this.isCarouselActive = true;
      this.classList.add('carousel-active');

      this.originalHTML = this.innerHTML;
      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      if (this.cells.length < 2) { this.isCarouselActive = false; this.classList.remove('carousel-active'); return; }

      var pageCounter = this.querySelector('.flickity-page-counter');
      var mediaNav = this.querySelector('.f-product__media-nav');

      var viewport = document.createElement('div');
      viewport.className = 'flickity-viewport';
      viewport.style.cssText = 'position:relative;overflow:hidden;width:100%';

      var slider = document.createElement('div');
      slider.className = 'flickity-slider';
      slider.style.cssText = 'display:flex;transition:transform 0.4s ease;will-change:transform';

      this.cells.forEach(function(cell) {
        cell.style.flexShrink = '0';
        cell.style.width = '100%';
        slider.appendChild(cell);
      });

      viewport.appendChild(slider);
      this.innerHTML = '';
      this.appendChild(viewport);

      if (pageCounter) {
        pageCounter.classList.remove('hidden');
        pageCounter.style.position = 'relative';
        pageCounter.style.zIndex = '2';
        this.appendChild(pageCounter);
      }

      if (mediaNav) {
        var self = this;
        this.appendChild(mediaNav);
        var prevBtn = mediaNav.querySelector('[data-media-nav-prev]');
        var nextBtn = mediaNav.querySelector('[data-media-nav-next]');
        if (prevBtn) prevBtn.addEventListener('click', function() { self.previous(); });
        if (nextBtn) nextBtn.addEventListener('click', function() { self.next(); });
      }

      this.viewport = viewport;
      this.slider = slider;

      if (this.options.prevNextButtons !== false) {
        this.createNavButtons();
      }

      if (this.options.pageDots) {
        this.createDots();
      }

      this.setupTouch();
      this.updateSlide(0);

      if (this.options.adaptiveHeight) {
        this.updateHeight();
      }
    }

    destroyCarousel() {
      if (!this.isCarouselActive) return;
      this.isCarouselActive = false;
      this.classList.remove('carousel-active');

      if (this.originalHTML) {
        this.innerHTML = this.originalHTML;
      }

      this.style.position = '';
      this.style.overflow = '';
      this.viewport = null;
      this.slider = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.dotsContainer = null;

      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      this.cells.forEach(function(cell) {
        cell.style.flexShrink = '';
        cell.style.width = '';
      });
    }

    createNavButtons() {
      var prev = document.createElement('button');
      prev.className = 'flickity-prev-next-button previous';
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>';
      prev.addEventListener('click', this.previous.bind(this));

      var next = document.createElement('button');
      next.className = 'flickity-prev-next-button next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>';
      next.addEventListener('click', this.next.bind(this));

      this.appendChild(prev);
      this.appendChild(next);
      this.prevBtn = prev;
      this.nextBtn = next;
    }

    createDots() {
      var self = this;
      var dots = document.createElement('div');
      dots.className = 'flickity-page-dots';

      this.cells.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'dot' + (i === 0 ? ' is-selected' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function() { self.updateSlide(i); });
        dots.appendChild(dot);
      });

      this.appendChild(dots);
      this.dotsContainer = dots;
    }

    setupTouch() {
      var self = this;
      var startX = 0;
      var startY = 0;
      var isDragging = false;
      var touchStartTarget = null;

      this.viewport.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        touchStartTarget = e.target;
        isDragging = true;
        self.slider.style.transition = 'none';
      }, { passive: true });

      this.viewport.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        isDragging = false;
        self.slider.style.transition = 'transform 0.4s ease';

        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var diffX = startX - endX;
        var diffY = startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            self.next();
          } else {
            self.previous();
          }
        } else {
          if (touchStartTarget && Math.abs(diffX) < 10 && Math.abs(diffY) < 10) {
            var cell = touchStartTarget.closest('.f-product__media');
            var zoomBtn = cell ? cell.querySelector('.js-product-zoom') : null;
            if (zoomBtn) {
              var mediaId = zoomBtn.dataset.mediaId;
              var modal = document.querySelector('[id^="ProductModal"]');
              if (modal && modal.open) {
                modal.open(mediaId);
                return;
              }
            }
          }
          self.updateSlide(self.currentIndex);
        }
      }, { passive: true });

      if (this.options.draggable !== false) {
        this.viewport.style.cursor = 'grab';

        var mouseStartTarget = null;
        this.viewport.addEventListener('mousedown', function(e) {
          e.preventDefault();
          mouseStartTarget = e.target;
          startX = e.clientX;
          isDragging = true;
          self.slider.style.transition = 'none';
          self.viewport.style.cursor = 'grabbing';
        });

        document.addEventListener('mousemove', function(e) {
          if (!isDragging) return;
          var diff = e.clientX - startX;
          var cellWidth = self.cells[0] ? self.cells[0].offsetWidth : 0;
          var sliderStyle = getComputedStyle(self.slider);
          var gap = parseFloat(sliderStyle.gap) || 0;
          var viewportWidth = self.viewport.offsetWidth;
          var centerOffset = (viewportWidth - cellWidth) / 2;
          var currentOffset = -(self.currentIndex * (cellWidth + gap)) + centerOffset;
          self.slider.style.transform = 'translateX(' + (currentOffset + diff) + 'px)';
        });

        document.addEventListener('mouseup', function(e) {
          if (!isDragging) return;
          isDragging = false;
          self.slider.style.transition = 'transform 0.4s ease';
          self.viewport.style.cursor = 'grab';

          var diffX = startX - e.clientX;
          if (Math.abs(diffX) > 40) {
            if (diffX > 0) {
              self.next();
            } else {
              self.previous();
            }
          } else {
            if (mouseStartTarget && Math.abs(diffX) < 5) {
              var cell = mouseStartTarget.closest('.f-product__media');
              var zoomBtn = cell ? cell.querySelector('.js-product-zoom') : null;
              if (zoomBtn) {
                var mediaId = zoomBtn.dataset.mediaId;
                var modal = document.querySelector('[id^="ProductModal"]');
                if (modal && modal.open) {
                  modal.open(mediaId);
                  return;
                }
              }
            }
            self.updateSlide(self.currentIndex);
          }
        });
      }
    }

    previous() {
      var idx = this.currentIndex - 1;
      if (this.options.wrapAround && idx < 0) {
        idx = this.cells.length - 1;
      }
      idx = Math.max(0, idx);
      this.updateSlide(idx);
    }

    next() {
      var idx = this.currentIndex + 1;
      if (this.options.wrapAround && idx >= this.cells.length) {
        idx = 0;
      }
      idx = Math.min(this.cells.length - 1, idx);
      this.updateSlide(idx);
    }

    updateSlide(index) {
      this.currentIndex = index;
      var cellWidth = this.cells[0] ? this.cells[0].offsetWidth : 0;
      var sliderStyle = this.slider ? getComputedStyle(this.slider) : null;
      var gap = sliderStyle ? parseFloat(sliderStyle.gap) || 0 : 0;
      var viewportWidth = this.viewport ? this.viewport.offsetWidth : cellWidth;
      var centerOffset = (viewportWidth - cellWidth) / 2;
      var step = cellWidth + gap;

      this.cells.forEach(function(cell) { cell.style.transform = ''; });

      if (this.options.wrapAround && this.cells.length > 1) {
        var totalWidth = this.cells.length * step;
        if (index === 0) {
          this.cells[this.cells.length - 1].style.transform = 'translateX(-' + totalWidth + 'px)';
        } else if (index === this.cells.length - 1) {
          this.cells[0].style.transform = 'translateX(' + totalWidth + 'px)';
        }
      }

      var offset = -(index * step) + centerOffset;
      this.slider.style.transform = 'translateX(' + offset + 'px)';

      if (this.dotsContainer) {
        this.dotsContainer.querySelectorAll('.dot').forEach(function(dot, i) {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      if (this.prevBtn && !this.options.wrapAround) {
        this.prevBtn.disabled = index === 0;
        this.nextBtn.disabled = index === this.cells.length - 1;
      }

      var counter = this.querySelector('.flickity-counter--current');
      if (counter) {
        counter.textContent = index + 1;
      }

      this.cells.forEach(function(cell, i) {
        cell.classList.toggle('is-selected', i === index);
      });

      if (this.options.adaptiveHeight) {
        this.updateHeight();
      }
    }

    updateHeight() {
      var cell = this.cells[this.currentIndex];
      if (cell && this.viewport) {
        this.viewport.style.height = cell.offsetHeight + 'px';
      }
    }
  }

  if (!customElements.get('flickity-component')) {
    customElements.define('flickity-component', FlickityComponent);
  }

  /* --- Responsive Image (loading indicator) --- */
  class ResponsiveImage extends HTMLElement {
    connectedCallback() {
      const img = this.querySelector('img');
      if (!img) return;

      if (img.complete) {
        this.removeAttribute('data-image-loading');
      } else {
        img.addEventListener('load', () => {
          this.removeAttribute('data-image-loading');
        }, { once: true });
      }
    }
  }

  if (!customElements.get('responsive-image')) {
    customElements.define('responsive-image', ResponsiveImage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;

      this.openDefault = this.dataset.openDefault === 'true';
      this.desktopBreakpoint = 1025;

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.details.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });

      this.mediaQuery = window.matchMedia('(min-width: ' + this.desktopBreakpoint + 'px)');
      this.mediaQuery.addEventListener('change', this.onBreakpointChange.bind(this));
      this.onBreakpointChange(this.mediaQuery);
    }

    onBreakpointChange(e) {
      var matches = e.matches !== undefined ? e.matches : e.matches;
      if (matches) {
        this.open();
        this.summary.setAttribute('aria-disabled', 'true');
      } else {
        this.summary.removeAttribute('aria-disabled');
        if (!this.openDefault) {
          this.close();
        }
      }
    }

    onSummaryClick(event) {
      if (this.mediaQuery.matches) {
        event.preventDefault();
        return;
      }
      event.preventDefault();
      this.details.hasAttribute('open') ? this.close() : this.open();
    }

    open() {
      this.details.setAttribute('open', '');
    }

    close() {
      this.details.removeAttribute('open');
    }
  }

  if (!customElements.get('footer-collapsible')) {
    customElements.define('footer-collapsible', FooterCollapsible);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["handpicked-products"] && !Shopify.designMode) return;
  try {
    
/* Handpicked Products - Slider (same pattern as product-tabs) */
(function() {
  var sections = document.querySelectorAll('[data-section-type="handpicked-products"]');

  sections.forEach(function(section) {
    initSlider(section);
  });

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-section-type="handpicked-products"]');
    if (section) initSlider(section);
  });

  function initSlider(section) {
    var slider = section.querySelector('[data-product-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;

    if (slider._sliderInit) {
      slider._sliderUpdate();
      return;
    }

    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dotsContainer = section.querySelector('[data-slider-dots]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 4;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;

      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';

      if (slideWidth === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap));
      if (slidesPerView === 0) slidesPerView = 1;
      var totalDots = Math.ceil(slides.length / slidesPerView);

      if (totalDots <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'hp__dot' + (i === 0 ? ' hp__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.dataset.dotIndex = i;
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.dotIndex);
          var spv = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
          var scrollTarget = idx * spv * (slideWidth + gap);
          slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.hp__dot');
      if (dots.length === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
      var currentGroup = Math.round(slider.scrollLeft / (slidesPerView * (slideWidth + gap)));

      dots.forEach(function(dot, i) {
        dot.classList.toggle('hp__dot--active', i === currentGroup);
      });
    }

    function update() {
      measure();
      updateNavState();
      createDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateNavState();
        updateDots();
      }, 50);
    });

    var resizeObserver = new ResizeObserver(function() {
      update();
    });
    resizeObserver.observe(slider);

    slider._sliderInit = true;
    slider._sliderUpdate = update;

    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/* ==============================================
   Header JavaScript
   - Drawer toggle (mobile nav, search, cart)
   - Sticky header (always / on-scroll-up)
   ============================================== */

(function() {
  'use strict';

  /* --- Drawer toggle --- */
  function openDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;

    var overlay = document.querySelector(
      '[data-header-drawer-overlay="' + drawerId + '"]'
    );

    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-visible');
    document.documentElement.style.overflow = 'hidden';

    /* Update aria on trigger */
    var trigger = document.querySelector(
      '[data-header-open-drawer="' + drawerId + '"]'
    );
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    setTimeout(function() { drawer.focus(); }, 100);
  }

  function closeDrawer(drawerId) {
    var drawer = document.getElementById(drawerId);
    if (!drawer) return;

    var overlay = document.querySelector(
      '[data-header-drawer-overlay="' + drawerId + '"]'
    );

    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-visible');
    document.documentElement.style.overflow = '';

    var trigger = document.querySelector(
      '[data-header-open-drawer="' + drawerId + '"]'
    );
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  }

  /* Bind open buttons */
  document.querySelectorAll('[data-header-open-drawer]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openDrawer(btn.getAttribute('data-header-open-drawer'));
    });
  });

  /* Bind close buttons */
  document.querySelectorAll('[data-header-close-drawer]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      closeDrawer(btn.getAttribute('data-header-close-drawer'));
    });
  });

  /* Bind overlays */
  document.querySelectorAll('[data-header-drawer-overlay]').forEach(function(el) {
    el.addEventListener('click', function() {
      closeDrawer(el.getAttribute('data-header-drawer-overlay'));
    });
  });

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.header-drawer.is-open').forEach(function(drawer) {
      closeDrawer(drawer.id);
    });
  });

  /* Animate drawer submenu open/close using the PDP collapsible-tab pattern.
     We intercept the summary click (rather than listening to `toggle`)
     because `toggle` fires after the browser has already painted the
     opened content at full height, causing a first-open flash. On close
     we keep `open=true` until the collapse animation finishes, then flip
     it so the browser doesn't snap the content away mid-animation. */
  document.querySelectorAll('.header-drawer details').forEach(function(details) {
    var summary = details.querySelector(':scope > summary');
    var content = details.querySelector(':scope > .header-drawer__submenu');
    if (!summary || !content) return;

    var animating = false;

    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (animating) return;

      if (details.open) {
        animating = true;
        content.style.height = content.scrollHeight + 'px';
        content.style.overflow = 'hidden';

        requestAnimationFrame(function() {
          content.style.height = '0';
          content.addEventListener('transitionend', function onEnd(ev) {
            if (ev.target !== content || ev.propertyName !== 'height') return;
            content.removeEventListener('transitionend', onEnd);
            details.open = false;
            content.style.height = '';
            content.style.overflow = '';
            animating = false;
          });
        });
        return;
      }

      animating = true;
      content.style.height = '0';
      content.style.overflow = 'hidden';
      details.open = true;

      requestAnimationFrame(function() {
        content.style.height = content.scrollHeight + 'px';
        content.addEventListener('transitionend', function onEnd(ev) {
          if (ev.target !== content || ev.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);
          content.style.height = '';
          content.style.overflow = '';
          animating = false;
        });
      });
    });
  });

  /* --- Transparent header: collapse header group so hero slides underneath --- */
  var transparentHeader = document.querySelector('.header--transparent');
  if (transparentHeader) {
    var groupSections = document.querySelectorAll('.shopify-section-group-header-group');
    if (groupSections.length) {
      var lastSection = groupSections[groupSections.length - 1];

      var collapseGroup = function() {
        var totalHeight = 0;
        groupSections.forEach(function(s) { totalHeight += s.offsetHeight; });
        lastSection.style.marginBottom = (-totalHeight) + 'px';
      };

      groupSections.forEach(function(s) { s.classList.add('header-group--overlay'); });
      collapseGroup();
      new ResizeObserver(collapseGroup).observe(groupSections[0]);
    }
  }

  /* --- Sticky header --- */
  var header = document.querySelector('[is="sticky-header"]');
  if (!header) return;

  /* Ensure the section wrapper is sticky (fallback for browsers without :has()) */
  var sectionWrapper = header.closest('.shopify-section');
  if (sectionWrapper) {
    sectionWrapper.style.position = 'sticky';
    sectionWrapper.style.top = '0';
    sectionWrapper.style.zIndex = '100';
  }

  var stickyType = header.getAttribute('data-sticky-type');
  var lastScrollY = 0;
  var ticking = false;

  function onScroll() {
    var scrollY = window.scrollY;
    var headerHeight = header.offsetHeight;

    /* Add scrolled-down class for solid bg on transparent headers */
    if (scrollY > headerHeight) {
      header.classList.add('header--scrolled-down');
    } else {
      header.classList.remove('header--scrolled-down');
    }

    /* on-scroll-up: hide/show based on scroll direction */
    if (stickyType === 'on-scroll-up') {
      if (scrollY > lastScrollY && scrollY > headerHeight) {
        header.classList.add('header--hidden');
      } else {
        header.classList.remove('header--hidden');
      }
    }

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  function initRelated(section) {
    var slider = section.querySelector('[data-related-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-related-slide]');
    if (slides.length === 0) return;

    if (slider._relatedInit) {
      slider._relatedUpdate();
      return;
    }

    var prevBtn = section.querySelector('[data-related-prev]');
    var nextBtn = section.querySelector('[data-related-next]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function update() {
      measure();
      updateNavState();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    var scrollTimeout;
    slider.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateNavState, 50);
    });

    var resizeObserver = new ResizeObserver(update);
    resizeObserver.observe(slider);

    slider._relatedInit = true;
    slider._relatedUpdate = update;
    update();
  }

  document.querySelectorAll('[data-related-carousel]').forEach(initRelated);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-related-carousel]');
    if (section) initRelated(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(function () {
  function initSort(section) {
    var select = section.querySelector('[data-sort-select]');
    var grid = section.querySelector('[data-sort-grid]');
    if (!select || !grid) return;
    if (section._blogSortInit) return;
    section._blogSortInit = true;

    var original = Array.prototype.slice.call(grid.children);

    function applyOrder(order) {
      var ordered = order === 'oldest' ? original.slice().reverse() : original;
      ordered.forEach(function (el) {
        grid.appendChild(el);
      });
    }

    function patchPaginationLinks(order) {
      var links = section.querySelectorAll('.f-pagination a');
      links.forEach(function (link) {
        try {
          var url = new URL(link.href, window.location.origin);
          if (order === 'oldest') {
            url.searchParams.set('sort', 'oldest');
          } else {
            url.searchParams.delete('sort');
          }
          link.href = url.pathname + url.search + url.hash;
        } catch (e) {}
      });
    }

    var params = new URLSearchParams(window.location.search);
    var current = params.get('sort') === 'oldest' ? 'oldest' : 'newest';
    select.value = current;
    applyOrder(current);
    patchPaginationLinks(current);

    select.addEventListener('change', function () {
      var order = select.value === 'oldest' ? 'oldest' : 'newest';
      applyOrder(order);
      patchPaginationLinks(order);

      var next = new URLSearchParams(window.location.search);
      if (order === 'oldest') {
        next.set('sort', 'oldest');
      } else {
        next.delete('sort');
      }
      var qs = next.toString();
      var url = window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
      window.history.replaceState({}, '', url);
    });
  }

  document.querySelectorAll('[data-blog-sort]').forEach(initSort);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-blog-sort]');
    if (section) initSort(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
/* ============================================================
   Web Components for Collection Page
   - DrawerComponent / DrawerOpener
   - FacetFiltersForm / FacetRemove / FacetApply
   - CollapsibleTab
   - PriceRange
   - ShowMoreButton
   - ProductGridContainer
   - Column switcher
   ============================================================ */

/* --- Drawer Component --- */
if (!customElements.get('drawer-component')) {
  class DrawerComponent extends HTMLElement {
    connectedCallback() {
      this._bindListeners();
    }
    /* Re-query child elements and attach listeners. Called on initial connect
       and after innerHTML is replaced by AJAX filter updates. */
    _bindListeners() {
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.closeBtn = this.querySelector('.f-drawer__close');
      this._content = this.querySelector('.f-drawer__content');
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
    }
    open() {
      /* Close all accordion tabs so drawer opens with everything collapsed */
      this.querySelectorAll('collapsible-tab[open]').forEach(function(tab) {
        if (tab.close) tab.close();
      });
      this.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      /* Let the browser paint the off-screen state before transitioning in */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.setAttribute('open', '');
        });
      });
      this.dispatchEvent(new CustomEvent('drawer:open'));
    }
    close() {
      this.removeAttribute('open');
      document.documentElement.style.overflow = '';
      /* Wait for the slide-out transition, then hide from the DOM */
      var self = this;
      var content = this._content;
      if (content) {
        content.addEventListener('transitionend', function handler() {
          content.removeEventListener('transitionend', handler);
          self.setAttribute('hidden', '');
        });
        /* Safety fallback in case transitionend doesn't fire */
        setTimeout(function() { if (!self.hasAttribute('hidden')) self.setAttribute('hidden', ''); }, 400);
      } else {
        this.setAttribute('hidden', '');
      }
      this.dispatchEvent(new CustomEvent('drawer:close'));
    }
  }
  customElements.define('drawer-component', DrawerComponent);
}

/* --- Drawer Opener --- */
if (!customElements.get('drawer-opener')) {
  class DrawerOpener extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button') || this;
      var sel = this.getAttribute('data-drawer');
      btn.addEventListener('click', function() {
        var drawer = document.querySelector(sel);
        if (drawer && drawer.open) drawer.open();
      });
    }
  }
  customElements.define('drawer-opener', DrawerOpener);
}

/* --- Collapsible Tab --- */
if (!customElements.get('collapsible-tab')) {
  class CollapsibleTab extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');
      if (this.getAttribute('data-destroy') === 'true') {
        if (this.content) this.content.removeAttribute('hidden');
        return;
      }
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.toggle());
      }
      if (this.hasAttribute('open') && this.content) {
        this.content.removeAttribute('hidden');
      }
    }
    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.openTab();
      }
    }
    openTab() {
      this.setAttribute('open', 'true');
      if (this.content) this.content.removeAttribute('hidden');
    }
    close() {
      this.removeAttribute('open');
      if (this.content) this.content.setAttribute('hidden', '');
    }
  }
  customElements.define('collapsible-tab', CollapsibleTab);
}

/* --- AJAX page renderer for facet filtering --- */
function renderCollectionPage(url) {
  var container = document.getElementById('ProductGridContainer');
  if (container) container.classList.add('loading');

  return fetch(url)
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');

      /* Update product grid container */
      var newContainer = doc.getElementById('ProductGridContainer');
      if (newContainer && container) {
        container.innerHTML = newContainer.innerHTML;
      }

      /* Update the filter drawer */
      var newDrawer = doc.getElementById('Drawer-Facets');
      var oldDrawer = document.getElementById('Drawer-Facets');
      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
        /* Re-bind overlay & close-button listeners lost by innerHTML swap */
        if (oldDrawer._bindListeners) oldDrawer._bindListeners();
      }

      /* Update product count badges */
      var newCounts = doc.querySelectorAll('[data-product-count]');
      var oldCounts = document.querySelectorAll('[data-product-count]');
      newCounts.forEach(function(el, i) {
        if (oldCounts[i]) oldCounts[i].innerHTML = el.innerHTML;
      });

      /* Push URL to history */
      history.pushState({}, '', url);

      if (container) container.classList.remove('loading');
    })
    .catch(function() {
      /* Fallback to full page load on error */
      window.location.href = url;
    });
}

/* --- Sort By Dropdown --- */
if (!customElements.get('sort-by-dropdown')) {
  class SortByDropdown extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.pgrid-sort__trigger');
      this.menu = this.querySelector('.pgrid-sort__menu');
      this.hiddenInput = this.closest('form').querySelector('input[name="sort_by"]');
      this.valueLabel = this.querySelector('[data-sort-value]');

      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });
      }

      if (this.menu) {
        this.menu.querySelectorAll('.pgrid-sort__option').forEach((opt) => {
          opt.addEventListener('click', () => this.select(opt));
        });
      }

      this._onClickOutside = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      document.addEventListener('click', this._onClickOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onClickOutside);
    }

    toggle() {
      if (this.menu.hidden) { this.open(); } else { this.close(); }
    }

    open() {
      this.menu.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
    }

    close() {
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.removeAttribute('open');
    }

    select(opt) {
      var value = opt.getAttribute('data-value');
      var label = opt.querySelector('span').textContent.trim();

      /* Update hidden input and label */
      if (this.hiddenInput) this.hiddenInput.value = value;
      if (this.valueLabel) this.valueLabel.textContent = label;

      /* Update active states */
      this.menu.querySelectorAll('.pgrid-sort__option').forEach(function(o) {
        o.classList.remove('pgrid-sort__option--active');
        o.removeAttribute('aria-selected');
        var check = o.querySelector('.pgrid-sort__check');
        if (check) check.remove();
      });
      opt.classList.add('pgrid-sort__option--active');
      opt.setAttribute('aria-selected', 'true');
      opt.insertAdjacentHTML('beforeend',
        '<svg class="pgrid-sort__check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );

      this.close();

      /* Trigger form change for AJAX filtering */
      var form = this.closest('form');
      if (form) {
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  customElements.define('sort-by-dropdown', SortByDropdown);
}

/* --- Facet Filters Form --- */
if (!customElements.get('facet-filters-form')) {
  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      /* Prevent native form submission — all filtering is handled via AJAX */
      this.form.addEventListener('submit', function(e) { e.preventDefault(); });
      /* Only auto-submit for sort form (not the drawer filter form) */
      var isDrawerForm = this.form.hasAttribute('data-facet-form');
      if (!isDrawerForm) {
        this.form.addEventListener('change', this.onFormChange.bind(this));
      }
    }
    onFormChange() {
      var formData = new FormData(this.form);
      var params = new URLSearchParams(formData);
      var cleanParams = new URLSearchParams();
      params.forEach(function(value, key) {
        if (value !== '' && value !== undefined) {
          cleanParams.append(key, value);
        }
      });
      var url = window.location.pathname + '?' + cleanParams.toString();
      renderCollectionPage(url);
    }
  }
  customElements.define('facet-filters-form', FacetFiltersForm);
}

/* --- Facet Remove --- */
if (!customElements.get('facet-remove')) {
  class FacetRemove extends HTMLElement {
    connectedCallback() {
      var self = this;
      var link = this.querySelector('a');
      if (!link) return;
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var drawer = self.closest('drawer-component');
        if (drawer && drawer.close) drawer.close();
        renderCollectionPage(link.getAttribute('href'));
      });
    }
  }
  customElements.define('facet-remove', FacetRemove);
}

/* --- Facet Apply (drawer mode) --- */
if (!customElements.get('facet-apply')) {
  class FacetApply extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var form = document.querySelector('[data-facet-form]');
        if (!form) return;
        var formData = new FormData(form);
        var params = new URLSearchParams();
        formData.forEach(function(value, key) {
          if (value !== '' && value !== undefined) {
            params.append(key, value);
          }
        });
        var drawer = this.closest('drawer-component');
        if (drawer && drawer.close) drawer.close();
        var url = window.location.pathname + '?' + params.toString();
        renderCollectionPage(url);
      }.bind(this));
    }
  }
  customElements.define('facet-apply', FacetApply);
}

/* --- Price Range --- */
if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('[data-type="min-range"]');
      this.maxRange = this.querySelector('[data-type="max-range"]');
      this.minInput = this.querySelector('[data-type="min-input"]');
      this.maxInput = this.querySelector('[data-type="max-input"]');
      var priceMax = parseFloat(this.getAttribute('data-price-max')) || 1000;
      var gap = parseFloat(this.getAttribute('data-price-gap')) || 5;
      var self = this;

      function updateSlider() {
        var minVal = parseFloat(self.minRange.value) || 0;
        var maxVal = parseFloat(self.maxRange.value) || priceMax;
        if (maxVal - minVal < gap) {
          if (this === self.minRange) {
            self.minRange.value = maxVal - gap;
            minVal = maxVal - gap;
          } else {
            self.maxRange.value = minVal + gap;
            maxVal = minVal + gap;
          }
        }
        self.style.setProperty('--price-min', (minVal / priceMax * 100) + '%');
        self.style.setProperty('--price-max', (maxVal / priceMax * 100) + '%');
        if (self.minInput) self.minInput.value = minVal;
        if (self.maxInput) self.maxInput.value = maxVal;
      }

      function updateFromInput() {
        var minVal = parseFloat(self.minInput.value) || 0;
        var maxVal = parseFloat(self.maxInput.value) || priceMax;
        if (self.minRange) self.minRange.value = minVal;
        if (self.maxRange) self.maxRange.value = maxVal;
        self.style.setProperty('--price-min', (minVal / priceMax * 100) + '%');
        self.style.setProperty('--price-max', (maxVal / priceMax * 100) + '%');
      }

      if (this.minRange) this.minRange.addEventListener('input', updateSlider);
      if (this.maxRange) this.maxRange.addEventListener('input', updateSlider);
      if (this.minInput) this.minInput.addEventListener('change', updateFromInput);
      if (this.maxInput) this.maxInput.addEventListener('change', updateFromInput);
    }
  }
  customElements.define('price-range', PriceRange);
}

/* --- Show More Button --- */
if (!customElements.get('show-more-button')) {
  class ShowMoreButton extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var facetBlock = this.closest('.f-facets__block') || this.closest('.js-filter');
        if (!facetBlock) return;
        var hiddenItems = facetBlock.querySelectorAll('.show-more-item');
        var labelMore = btn.querySelector('.label-show-more');
        var labelLess = btn.querySelector('.label-show-less');
        var isExpanded = labelMore && labelMore.classList.contains('hidden');

        hiddenItems.forEach(function(item) {
          if (isExpanded) {
            item.classList.add('hidden');
          } else {
            item.classList.remove('hidden');
          }
        });

        if (labelMore && labelLess) {
          labelMore.classList.toggle('hidden');
          labelLess.classList.toggle('hidden');
        }
      }.bind(this));
    }
  }
  customElements.define('show-more-button', ShowMoreButton);
}

/* --- Product Grid Container (pass-through) --- */
if (!customElements.get('product-grid-container')) {
  class ProductGridContainer extends HTMLElement {}
  customElements.define('product-grid-container', ProductGridContainer);
}

/* --- Motion Element (pass-through for Zest framework compat) --- */
if (!customElements.get('motion-element')) {
  class MotionElement extends HTMLElement {}
  customElements.define('motion-element', MotionElement);
}

/* --- Filter Color Swatch (pass-through) --- */
if (!customElements.get('filter-color-swatch')) {
  class FilterColorSwatch extends HTMLElement {}
  customElements.define('filter-color-swatch', FilterColorSwatch);
}

/* --- Product Form (pass-through for product card quick-add) --- */
if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {}
  customElements.define('product-form', ProductForm);
}

/* --- Flickity Component (pass-through for slider sections) --- */
if (!customElements.get('flickity-component')) {
  class FlickityComponent extends HTMLElement {}
  customElements.define('flickity-component', FlickityComponent);
}

/* --- Handle browser back/forward for AJAX filtering --- */
window.addEventListener('popstate', function() {
  renderCollectionPage(window.location.href);
});

/* --- Sticky filter bar: measure header height --- */
(function() {
  function setStickyTop() {
    var header = document.querySelector('.f-section-header, .shopify-section-header, header');
    var top = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-filter-top', top + 'px');
  }
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
})();

/* --- Column Switcher for mobile --- */
(function() {
  var container = document.querySelector('[data-column-switcher]');
  if (!container) return;
  var buttons = container.querySelectorAll('[data-column]');
  var grid = document.querySelector('[data-products-grid]');
  if (!buttons.length || !grid) return;

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var cols = this.getAttribute('data-column');
      buttons.forEach(function(b) {
        b.classList.remove('pgrid-col-switcher__btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('pgrid-col-switcher__btn--active');
      this.setAttribute('aria-pressed', 'true');
      grid.setAttribute('data-mobile-columns', cols);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-password"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('password-modal');
    if (!root) return;
    const details = root.querySelector('details.password-modal');
    if (!details) return;

    const overlay = root.querySelector('[data-password-overlay]');
    const closeBtn = root.querySelector('[data-password-close]');
    const input = root.querySelector('#Password');

    function close() {
      details.open = false;
    }

    details.addEventListener('toggle', function () {
      if (details.open && input) {
        // Defer focus to next frame so the dialog is painted
        requestAnimationFrame(function () { input.focus(); });
      }
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && details.open) close();
    });

    // If the form has server-rendered errors on load, open the modal so the user sees them
    if (document.getElementById('PasswordLoginForm-password-error')) {
      details.open = true;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* --- Product Modal (Zoom) --- */
  class ProductModal extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.items = [];
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.product-zoom__item'));
      this.closeButton = this.querySelector('[id^="ModalClose"]');
      this.prevButton = this.querySelector('[data-zoom-prev]');
      this.nextButton = this.querySelector('[data-zoom-next]');

      if (this.closeButton) this.closeButton.addEventListener('click', () => this.close());
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.navigate(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.navigate(1));

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'ArrowLeft') this.navigate(-1);
        if (e.key === 'ArrowRight') this.navigate(1);
      });

      this.querySelectorAll('[data-zoom-wrapper]').forEach((wrapper) => {
        wrapper.addEventListener('click', (e) => {
          if (wrapper._wasDragged) {
            wrapper._wasDragged = false;
            return;
          }
          this.toggleZoom(wrapper, e);
        });
      });
    }

    open(mediaId) {
      this.removeAttribute('hidden');
      this.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';

      /* Find index of target media */
      var targetIndex = 0;
      if (mediaId) {
        this.items.forEach(function(item, i) {
          if (item.dataset.mediaId === String(mediaId)) targetIndex = i;
        });
      }

      this.showItem(targetIndex);
      this.focus();
    }

    close() {
      this.setAttribute('hidden', '');
      this.removeAttribute('open');
      document.documentElement.style.overflow = '';
      this.resetZoom();
    }

    resetZoom() {
      var self = this;
      this.querySelectorAll('.is-zoomed').forEach(function(el) {
        el.classList.remove('is-zoomed');
        var img = el.querySelector('.product-zoom__image');
        if (img) img.style.transform = '';
        self.cleanupDrag(el);
      });
    }

    showItem(index) {
      if (index < 0) index = this.items.length - 1;
      if (index >= this.items.length) index = 0;
      this.currentIndex = index;

      /* Desktop: show only the active item */
      this.items.forEach(function(item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    navigate(direction) {
      this.resetZoom();
      this.showItem(this.currentIndex + direction);
    }

    toggleZoom(wrapper, event) {
      var img = wrapper.querySelector('.product-zoom__image');
      if (!img) return;

      var isZoomed = wrapper.classList.contains('is-zoomed');
      if (isZoomed) {
        wrapper.classList.remove('is-zoomed');
        img.style.transform = '';
        this.cleanupDrag(wrapper);
      } else {
        var preRect = wrapper.getBoundingClientRect();
        var clickX = (event.clientX - preRect.left) / preRect.width;
        var clickY = (event.clientY - preRect.top) / preRect.height;

        wrapper.classList.add('is-zoomed');

        /* Get wrapper and actual image dimensions after layout change */
        var rect = wrapper.getBoundingClientRect();
        var imgW = img.offsetWidth || rect.width;
        var imgH = img.offsetHeight || rect.height;

        var scale = 1.8;
        var tx = -(clickX * imgW * (scale - 1));
        var ty = -(clickY * imgH * (scale - 1));

        /* Clamp so image doesn't go past edges */
        tx = Math.min(0, Math.max(tx, rect.width - imgW * scale));
        ty = Math.min(0, Math.max(ty, rect.height - imgH * scale));

        img.style.transform = 'scale(' + scale + ') translate(' + (tx / scale) + 'px, ' + (ty / scale) + 'px)';

        this.setupDrag(wrapper, img, scale, rect.width, rect.height, imgW, imgH);
      }
    }

    setupDrag(wrapper, img, scale, wrapW, wrapH, imgW, imgH) {
      var self = this;
      var startX, startY, currentTx, currentTy;
      var isDragging = false;

      function getTranslate() {
        var t = img.style.transform;
        var match = t.match(/translate\(([^,]+)px,\s*([^)]+)px\)/);
        if (match) {
          return { x: parseFloat(match[1]) * scale, y: parseFloat(match[2]) * scale };
        }
        return { x: 0, y: 0 };
      }

      function clamp(val, min, max) {
        return Math.min(max, Math.max(min, val));
      }

      function onPointerDown(e) {
        if (!wrapper.classList.contains('is-zoomed')) return;
        e.preventDefault();
        isDragging = true;
        wrapper.classList.add('is-dragging');
        startX = e.clientX;
        startY = e.clientY;
        var t = getTranslate();
        currentTx = t.x;
        currentTy = t.y;
      }

      function onPointerMove(e) {
        if (!isDragging) return;
        e.preventDefault();
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        var newTx = clamp(currentTx + dx, wrapW - imgW * scale, 0);
        var newTy = clamp(currentTy + dy, wrapH - imgH * scale, 0);
        img.style.transform = 'scale(' + scale + ') translate(' + (newTx / scale) + 'px, ' + (newTy / scale) + 'px)';
      }

      function onPointerUp(e) {
        if (!isDragging) return;
        isDragging = false;
        wrapper.classList.remove('is-dragging');
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if (dx >= 5 || dy >= 5) {
          wrapper._wasDragged = true;
        }
      }

      wrapper.addEventListener('pointerdown', onPointerDown, { passive: false });
      document.addEventListener('pointermove', onPointerMove, { passive: false });
      document.addEventListener('pointerup', onPointerUp);

      wrapper._dragCleanup = function() {
        wrapper.removeEventListener('pointerdown', onPointerDown);
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        wrapper.classList.remove('is-dragging');
        delete wrapper._dragCleanup;
      };
    }

    cleanupDrag(wrapper) {
      if (wrapper._dragCleanup) wrapper._dragCleanup();
    }
  }

  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', ProductModal);
  }

  /* --- Media Gallery --- */
  class MediaGallery extends HTMLElement {
    connectedCallback() {
      /* Use event delegation so it works even after carousel rebuilds DOM */
      this.addEventListener('click', function(e) {
        var btn = e.target.closest('.js-product-zoom');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var mediaId = btn.dataset.mediaId;
        var modal = document.querySelector('[id^="ProductModal"]');
        if (modal && modal.open) {
          modal.open(mediaId);
        }
      });

      /* On mobile, also allow tap on the image itself (not just the invisible button) */
      this.addEventListener('pointerup', function(e) {
        if (e.pointerType !== 'touch') return;
        var btn = e.target.closest('.js-product-zoom');
        if (!btn) return;
        var mediaId = btn.dataset.mediaId;
        var modal = document.querySelector('[id^="ProductModal"]');
        if (modal && modal.open) {
          modal.open(mediaId);
        }
      });
    }
  }

  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }

  /* --- Collapsible Tab --- */
  class CollapsibleTab extends HTMLElement {
    constructor() {
      super();
      this.trigger = null;
      this.content = null;
    }

    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');

      if (!this.trigger || !this.content) return;

      this.trigger.addEventListener('click', () => this.toggle());

      if (this.getAttribute('open') === 'true') {
        this.expand(false);
      }
    }

    toggle() {
      if (this.getAttribute('open') === 'true') {
        this.collapse();
      } else {
        this.expand(true);
      }
    }

    expand(animate) {
      this.setAttribute('open', 'true');
      this.content.removeAttribute('hidden');

      if (animate) {
        this.content.style.height = '0';
        this.content.style.overflow = 'hidden';
        requestAnimationFrame(() => {
          this.content.style.height = this.content.scrollHeight + 'px';
          this.content.addEventListener('transitionend', () => {
            this.content.style.height = '';
            this.content.style.overflow = '';
          }, { once: true });
        });
      }
    }

    collapse() {
      this.setAttribute('open', 'false');
      this.content.style.height = this.content.scrollHeight + 'px';
      this.content.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        this.content.style.height = '0';
        this.content.addEventListener('transitionend', () => {
          this.content.setAttribute('hidden', '');
          this.content.style.height = '';
          this.content.style.overflow = '';
        }, { once: true });
      });
    }
  }

  if (!customElements.get('collapsible-tab')) {
    customElements.define('collapsible-tab', CollapsibleTab);
  }

  /* --- Quantity Input --- */
  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.f-quantity__input');
      this.minusBtn = this.querySelector('[name="minus"]');
      this.plusBtn = this.querySelector('[name="plus"]');

      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', () => this.step(-1));
      }
      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', () => this.step(1));
      }
    }

    step(direction) {
      if (!this.input) return;
      const step = parseInt(this.input.step) || 1;
      const min = parseInt(this.input.min) || 1;
      const max = this.input.max ? parseInt(this.input.max) : Infinity;
      let value = parseInt(this.input.value) || min;

      value += step * direction;
      value = Math.max(min, Math.min(max, value));

      this.input.value = value;
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  /* --- Product Form --- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.onSubmit();
      });
    }

    async onSubmit() {
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

      const submitText = submitButton.querySelector('.f-product-form__submit-text');
      const originalText = submitText ? submitText.textContent : null;
      const addingText = submitButton.dataset.addingText;

      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.disabled = true;
      submitButton.classList.add('loading');
      if (submitText && addingText) submitText.textContent = addingText;

      /* Ensure variant ID input is included (may be disabled until variant-picker enables it) */
      const idInput = this.form.querySelector('input[name="id"]');
      if (idInput && idInput.disabled) idInput.disabled = false;

      const formData = new FormData(this.form);
      const body = new URLSearchParams(formData);

      try {
        const response = await fetch('/cart/add', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: body.toString(),
        });

        if (response.ok) {
          const cartResponse = await fetch('/cart.js', {
            headers: { 'Content-Type': 'application/json' },
          });
          const cart = await cartResponse.json();

          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: { cart } })
          );
        } else {
          const error = await response.json();
          const errorWrapper = this.querySelector('.f-product-form__error-message-wrapper');
          if (errorWrapper) {
            errorWrapper.textContent = error.description || error.message || 'Error adding to cart';
          }
        }
      } catch (err) {
        /* silent */
      } finally {
        submitButton.removeAttribute('aria-disabled');
        submitButton.disabled = false;
        submitButton.classList.remove('loading');
        if (submitText && originalText !== null) submitText.textContent = originalText;
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  /* --- Product Info (Variant Change Handler) --- */
  class ProductInfo extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.productId = this.dataset.productId;
    }
  }

  if (!customElements.get('product-info')) {
    customElements.define('product-info', ProductInfo);
  }

  /* --- Variant Picker --- */
  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onVariantChange.bind(this));
      this.productData = null;

      const productDataEl = document.querySelector('#ProductData');
      if (productDataEl) {
        try {
          this.productData = JSON.parse(productDataEl.textContent);
        } catch (e) {
          /* empty */
        }
      }

      /* If a hidden option override is present (e.g. gift card forced to Digital),
         sync the form's variant id on load. */
      if (this.querySelector('.variant-picker__field[hidden] input[type="radio"]:checked')) {
        this.onVariantChange();
      }
    }

    onVariantChange() {
      this.updateSelectedValues();
      const variant = this.getSelectedVariant();
      if (!variant) return;

      this.updateURL(variant);
      this.updateFormId(variant);
      this.updatePrice(variant);
      this.updateButton(variant);
      this.updateMedia(variant);

      document.dispatchEvent(
        new CustomEvent('variant:changed', { detail: variant })
      );
    }

    updateSelectedValues() {
      this.querySelectorAll('.selected-value').forEach((el) => {
        const field = el.closest('.variant-picker__field');
        if (!field) return;

        const checked = field.querySelector('input[type="radio"]:checked');
        if (checked) {
          el.textContent = checked.value;
          return;
        }

        const select = field.querySelector('select');
        if (select) {
          el.textContent = select.value;
        }
      });
    }

    getSelectedVariant() {
      if (!this.productData) return null;

      const defaultVariant =
        this.productData.selected_or_first_available_variant ||
        (this.productData.variants && this.productData.variants[0]);
      if (!defaultVariant) return null;

      const options = defaultVariant.options.slice();
      const productOptions = this.productData.options || [];

      this.querySelectorAll('.variant-picker__field').forEach((field) => {
        const optionName = field.dataset.optionName;
        if (!optionName) return;

        let index = -1;
        for (let i = 0; i < productOptions.length; i++) {
          const opt = productOptions[i];
          const name = typeof opt === 'string' ? opt : (opt && opt.name);
          if (name === optionName) { index = i; break; }
        }
        if (index === -1) return;

        const checked = field.querySelector('input[type="radio"]:checked');
        if (checked) { options[index] = checked.value; return; }
        const select = field.querySelector('select');
        if (select) options[index] = select.value;
      });

      return this.productData.variants.find((variant) => {
        return variant.options.every((opt, i) => opt === options[i]);
      });
    }

    updateURL(variant) {
      if (this.dataset.updateUrl !== 'true') return;
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    updateFormId(variant) {
      const forms = document.querySelectorAll('input[name="id"]');
      forms.forEach((input) => {
        input.value = variant.id;
        input.removeAttribute('disabled');
      });
    }

    updatePrice(variant) {
      const priceContainer = document.querySelector('[id^="Price-"]');
      if (!priceContainer) return;

      const priceEl = priceContainer.querySelector('.f-price');
      if (!priceEl) return;

      const formatMoney = (cents) => {
        const open = '{' + '{';
        const close = '}' + '}';
        const format = (window.FoxThemeSettings && window.FoxThemeSettings.money_format) || ('$' + open + 'amount' + close);
        if (cents == null || isNaN(cents)) return '';
        const dollars = Number(cents) / 100;
        const amount = dollars.toFixed(2);
        const amountNoDecimals = Math.floor(dollars).toString();
        const amountWithComma = amount.replace('.', ',');
        return format
          .replace(open + 'amount_with_comma_separator' + close, amountWithComma)
          .replace(open + 'amount_no_decimals_with_comma_separator' + close, amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1.'))
          .replace(open + 'amount_no_decimals' + close, amountNoDecimals)
          .replace(open + 'amount' + close, amount);
      };

      const priceMoney = formatMoney(variant.price);
      priceEl.querySelectorAll('.f-price__regular .f-price-item--regular').forEach((el) => {
        el.textContent = priceMoney;
      });
      priceEl.querySelectorAll('.f-price__sale .f-price-item--sale').forEach((el) => {
        el.textContent = priceMoney;
      });

      const compareEl = priceEl.querySelector('.f-price__sale s.f-price-item--regular');
      if (compareEl) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
      }

      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      priceEl.classList.toggle('f-price--on-sale', !!onSale);
      priceEl.classList.toggle('f-price--sold-out', variant.available === false);
    }

    updateButton(variant) {
      const button = document.querySelector('.f-product-form__submit');
      if (!button) return;
      const span = button.querySelector('span');

      if (variant.available) {
        button.removeAttribute('disabled');
        if (span) span.textContent = button.dataset.addText || 'Add to bag';
      } else {
        button.setAttribute('disabled', '');
        if (span) span.textContent = button.dataset.soldText || 'Sold out';
      }
    }

    updateMedia(variant) {
      if (!variant.featured_media) return;
      const gallery = document.querySelector('media-gallery');
      if (!gallery) return;

      const targetMedia = gallery.querySelector(
        '[data-media-id="' + variant.featured_media.id + '"]'
      );
      if (targetMedia) {
        targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

  /* --- Modal Dialog / Opener --- */
  class ModalDialog extends HTMLElement {
    connectedCallback() {
      this.closeBtn = this.querySelector('[id^="ModalClose"]');
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      const overlay = this.querySelector('[data-modal-overlay]');
      if (overlay) {
        overlay.addEventListener('click', () => this.close());
      }

      this.addEventListener('click', (e) => {
        if (e.target === this) this.close();
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      this.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  }

  if (!customElements.get('modal-dialog')) {
    customElements.define('modal-dialog', ModalDialog);
  }

  class ModalOpener extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      if (!button) return;

      button.addEventListener('click', () => {
        const modalId = this.dataset.modal;
        if (!modalId) return;
        const modal = document.querySelector(modalId);
        if (modal && modal.open) {
          modal.open();
        }
      });
    }
  }

  if (!customElements.get('modal-opener')) {
    customElements.define('modal-opener', ModalOpener);
  }

  /* --- Flickity Component (Lightweight Carousel) --- */
  class FlickityComponent extends HTMLElement {
    connectedCallback() {
      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      if (this.cells.length < 2) return;

      this.currentIndex = 0;
      this.options = this.getOptions();
      this.isResponsive = this.classList.contains('md:flickity-disable');
      this.isEnabled = this.dataset.enableSlider === 'true';

      if (this.isResponsive) {
        this.mediaQuery = window.matchMedia('(min-width: 1025px)');
        this.handleResize = () => this.onResize();
        this.mediaQuery.addEventListener('change', this.handleResize);
        this.onResize();
      } else if (this.isEnabled) {
        this.setupCarousel();
      }
    }

    disconnectedCallback() {
      if (this.mediaQuery && this.handleResize) {
        this.mediaQuery.removeEventListener('change', this.handleResize);
      }
    }

    onResize() {
      if (this.mediaQuery.matches) {
        this.destroyCarousel();
      } else {
        if (!this.isCarouselActive) {
          this.setupCarousel();
        }
      }
    }

    getCellSelector() {
      try {
        var opts = JSON.parse(this.dataset.sliderOptions || '{}');
        return opts.cellSelector || ':scope > *';
      } catch (e) {
        return ':scope > *';
      }
    }

    getOptions() {
      try {
        return JSON.parse(this.dataset.sliderOptions || '{}');
      } catch (e) {
        return {};
      }
    }

    setupCarousel() {
      if (this.isCarouselActive) return;
      this.isCarouselActive = true;
      this.classList.add('carousel-active');

      this.originalHTML = this.innerHTML;
      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      if (this.cells.length < 2) { this.isCarouselActive = false; this.classList.remove('carousel-active'); return; }

      var pageCounter = this.querySelector('.flickity-page-counter');
      var mediaNav = this.querySelector('.f-product__media-nav');

      var viewport = document.createElement('div');
      viewport.className = 'flickity-viewport';
      viewport.style.cssText = 'position:relative;overflow:hidden;width:100%';

      var slider = document.createElement('div');
      slider.className = 'flickity-slider';
      slider.style.cssText = 'display:flex;transition:transform 0.4s ease;will-change:transform';

      this.cells.forEach(function(cell) {
        cell.style.flexShrink = '0';
        cell.style.width = '100%';
        slider.appendChild(cell);
      });

      viewport.appendChild(slider);
      this.innerHTML = '';
      this.appendChild(viewport);

      if (pageCounter) {
        pageCounter.classList.remove('hidden');
        pageCounter.style.position = 'relative';
        pageCounter.style.zIndex = '2';
        this.appendChild(pageCounter);
      }

      if (mediaNav) {
        var self = this;
        this.appendChild(mediaNav);
        var prevBtn = mediaNav.querySelector('[data-media-nav-prev]');
        var nextBtn = mediaNav.querySelector('[data-media-nav-next]');
        if (prevBtn) prevBtn.addEventListener('click', function() { self.previous(); });
        if (nextBtn) nextBtn.addEventListener('click', function() { self.next(); });
      }

      this.viewport = viewport;
      this.slider = slider;

      if (this.options.prevNextButtons !== false) {
        this.createNavButtons();
      }

      if (this.options.pageDots) {
        this.createDots();
      }

      this.setupTouch();
      this.updateSlide(0);

      if (this.options.adaptiveHeight) {
        this.updateHeight();
      }
    }

    destroyCarousel() {
      if (!this.isCarouselActive) return;
      this.isCarouselActive = false;
      this.classList.remove('carousel-active');

      if (this.originalHTML) {
        this.innerHTML = this.originalHTML;
      }

      this.style.position = '';
      this.style.overflow = '';
      this.viewport = null;
      this.slider = null;
      this.prevBtn = null;
      this.nextBtn = null;
      this.dotsContainer = null;

      this.cells = Array.from(this.querySelectorAll(this.getCellSelector()));
      this.cells.forEach(function(cell) {
        cell.style.flexShrink = '';
        cell.style.width = '';
      });
    }

    createNavButtons() {
      var prev = document.createElement('button');
      prev.className = 'flickity-prev-next-button previous';
      prev.type = 'button';
      prev.setAttribute('aria-label', 'Previous');
      prev.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>';
      prev.addEventListener('click', this.previous.bind(this));

      var next = document.createElement('button');
      next.className = 'flickity-prev-next-button next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Next');
      next.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>';
      next.addEventListener('click', this.next.bind(this));

      this.appendChild(prev);
      this.appendChild(next);
      this.prevBtn = prev;
      this.nextBtn = next;
    }

    createDots() {
      var self = this;
      var dots = document.createElement('div');
      dots.className = 'flickity-page-dots';

      this.cells.forEach(function(_, i) {
        var dot = document.createElement('button');
        dot.className = 'dot' + (i === 0 ? ' is-selected' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Slide ' + (i + 1));
        dot.addEventListener('click', function() { self.updateSlide(i); });
        dots.appendChild(dot);
      });

      this.appendChild(dots);
      this.dotsContainer = dots;
    }

    setupTouch() {
      var self = this;
      var startX = 0;
      var startY = 0;
      var isDragging = false;
      var touchStartTarget = null;

      /* Touch events (mobile) */
      this.viewport.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        touchStartTarget = e.target;
        isDragging = true;
        self.slider.style.transition = 'none';
      }, { passive: true });

      this.viewport.addEventListener('touchend', function(e) {
        if (!isDragging) return;
        isDragging = false;
        self.slider.style.transition = 'transform 0.4s ease';

        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var diffX = startX - endX;
        var diffY = startY - endY;

        if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 40) {
          if (diffX > 0) {
            self.next();
          } else {
            self.previous();
          }
        } else {
          /* It's a tap — find zoom button or product card link */
          if (touchStartTarget && Math.abs(diffX) < 10 && Math.abs(diffY) < 10) {
            var productCard = touchStartTarget.closest('.product-card[data-product-url]');
            if (productCard) {
              window.location.href = productCard.dataset.productUrl;
              return;
            }
            var cell = touchStartTarget.closest('.f-product__media');
            var zoomBtn = cell ? cell.querySelector('.js-product-zoom') : null;
            if (zoomBtn) {
              var mediaId = zoomBtn.dataset.mediaId;
              var modal = document.querySelector('[id^="ProductModal"]');
              if (modal && modal.open) {
                modal.open(mediaId);
                return;
              }
            }
          }
          self.updateSlide(self.currentIndex);
        }
      }, { passive: true });

      /* Mouse events (desktop drag) */
      if (this.options.draggable !== false) {
        this.viewport.style.cursor = 'grab';

        var mouseStartTarget = null;
        this.viewport.addEventListener('mousedown', function(e) {
          e.preventDefault();
          mouseStartTarget = e.target;
          startX = e.clientX;
          isDragging = true;
          self.slider.style.transition = 'none';
          self.viewport.style.cursor = 'grabbing';
        });

        document.addEventListener('mousemove', function(e) {
          if (!isDragging) return;
          var diff = e.clientX - startX;
          var cellWidth = self.cells[0] ? self.cells[0].offsetWidth : 0;
          var sliderStyle = getComputedStyle(self.slider);
          var gap = parseFloat(sliderStyle.gap) || 0;
          var viewportWidth = self.viewport.offsetWidth;
          var centerOffset = (viewportWidth - cellWidth) / 2;
          var currentOffset = -(self.currentIndex * (cellWidth + gap)) + centerOffset;
          self.slider.style.transform = 'translateX(' + (currentOffset + diff) + 'px)';
        });

        document.addEventListener('mouseup', function(e) {
          if (!isDragging) return;
          isDragging = false;
          self.slider.style.transition = 'transform 0.4s ease';
          self.viewport.style.cursor = 'grab';

          var diffX = startX - e.clientX;
          if (Math.abs(diffX) > 40) {
            if (diffX > 0) {
              self.next();
            } else {
              self.previous();
            }
          } else {
            /* Click (no drag) — find product card link or zoom button */
            if (mouseStartTarget && Math.abs(diffX) < 5) {
              var productCard = mouseStartTarget.closest('.product-card[data-product-url]');
              if (productCard) {
                window.location.href = productCard.dataset.productUrl;
                return;
              }
              var cell = mouseStartTarget.closest('.f-product__media');
              var zoomBtn = cell ? cell.querySelector('.js-product-zoom') : null;
              if (zoomBtn) {
                var mediaId = zoomBtn.dataset.mediaId;
                var modal = document.querySelector('[id^="ProductModal"]');
                if (modal && modal.open) {
                  modal.open(mediaId);
                  return;
                }
              }
            }
            self.updateSlide(self.currentIndex);
          }
        });
      }
    }

    previous() {
      var idx = this.currentIndex - 1;
      if (this.options.wrapAround && idx < 0) {
        idx = this.cells.length - 1;
      }
      idx = Math.max(0, idx);
      this.updateSlide(idx);
    }

    next() {
      var idx = this.currentIndex + 1;
      if (this.options.wrapAround && idx >= this.cells.length) {
        idx = 0;
      }
      idx = Math.min(this.cells.length - 1, idx);
      this.updateSlide(idx);
    }

    updateSlide(index) {
      this.currentIndex = index;
      var cellWidth = this.cells[0] ? this.cells[0].offsetWidth : 0;
      var sliderStyle = this.slider ? getComputedStyle(this.slider) : null;
      var gap = sliderStyle ? parseFloat(sliderStyle.gap) || 0 : 0;
      var viewportWidth = this.viewport ? this.viewport.offsetWidth : cellWidth;
      var centerOffset = (viewportWidth - cellWidth) / 2;
      var step = cellWidth + gap;

      /* Reset all cell transforms */
      this.cells.forEach(function(cell) { cell.style.transform = ''; });

      /* Wrap-around: reposition edge cells so they peek */
      if (this.options.wrapAround && this.cells.length > 1) {
        var totalWidth = this.cells.length * step;
        if (index === 0) {
          /* Move last cell before the first */
          this.cells[this.cells.length - 1].style.transform = 'translateX(-' + totalWidth + 'px)';
        } else if (index === this.cells.length - 1) {
          /* Move first cell after the last */
          this.cells[0].style.transform = 'translateX(' + totalWidth + 'px)';
        }
      }

      var offset = -(index * step) + centerOffset;
      this.slider.style.transform = 'translateX(' + offset + 'px)';

      if (this.dotsContainer) {
        this.dotsContainer.querySelectorAll('.dot').forEach(function(dot, i) {
          dot.classList.toggle('is-selected', i === index);
        });
      }

      if (this.prevBtn && !this.options.wrapAround) {
        this.prevBtn.disabled = index === 0;
        this.nextBtn.disabled = index === this.cells.length - 1;
      }

      var counter = this.querySelector('.flickity-counter--current');
      if (counter) {
        counter.textContent = index + 1;
      }

      this.cells.forEach(function(cell, i) {
        cell.classList.toggle('is-selected', i === index);
      });

      if (this.options.adaptiveHeight) {
        this.updateHeight();
      }
    }

    updateHeight() {
      var cell = this.cells[this.currentIndex];
      if (cell && this.viewport) {
        this.viewport.style.height = cell.offsetHeight + 'px';
      }
    }
  }

  if (!customElements.get('flickity-component')) {
    customElements.define('flickity-component', FlickityComponent);
  }

  /* --- Responsive Image (loading indicator) --- */
  class ResponsiveImage extends HTMLElement {
    connectedCallback() {
      const img = this.querySelector('img');
      if (!img) return;

      if (img.complete) {
        this.removeAttribute('data-image-loading');
      } else {
        img.addEventListener('load', () => {
          this.removeAttribute('data-image-loading');
        }, { once: true });
      }
    }
  }

  if (!customElements.get('responsive-image')) {
    customElements.define('responsive-image', ResponsiveImage);
  }

  /* --- Product Recently Viewed (Tracking) --- */
  class ProductRecentlyViewed extends HTMLElement {
    connectedCallback() {
      const productId = this.dataset.productId;
      if (!productId) return;

      const key = 'recently-viewed';
      let items = [];

      try {
        items = JSON.parse(localStorage.getItem(key) || '[]');
      } catch (e) {
        items = [];
      }

      items = items.filter((id) => id !== productId);
      items.unshift(productId);
      items = items.slice(0, 20);

      try {
        localStorage.setItem(key, JSON.stringify(items));
      } catch (e) {
        /* storage full */
      }
    }
  }

  if (!customElements.get('product-recently-viewed')) {
    customElements.define('product-recently-viewed', ProductRecentlyViewed);
  }

  /* --- Product Recommendations (Fetch) --- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');
          const source = doc.querySelector('product-recommendations');
          if (source && source.innerHTML.trim()) {
            this.innerHTML = source.innerHTML;
          }
        })
        .catch(() => {
          /* silently fail */
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
/* ============================================================
   Web Components for Search Results Page
   Shared with collection grid -- needed for filter drawer,
   AJAX filtering, and accordion behavior.
   ============================================================ */

/* --- Drawer Component --- */
if (!customElements.get('drawer-component')) {
  class DrawerComponent extends HTMLElement {
    connectedCallback() {
      this._bindListeners();
    }
    /* Re-query child elements and attach listeners. Called on initial connect
       and after innerHTML is replaced by AJAX filter updates. */
    _bindListeners() {
      this.overlay = this.querySelector('[data-drawer-overlay]');
      this.closeBtn = this.querySelector('.f-drawer__close');
      this._content = this.querySelector('.f-drawer__content');
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
    }
    open() {
      /* Close all accordion tabs so drawer opens with everything collapsed */
      this.querySelectorAll('collapsible-tab[open]').forEach(function(tab) {
        if (tab.close) tab.close();
      });
      this.removeAttribute('hidden');
      document.documentElement.style.overflow = 'hidden';
      /* Let the browser paint the off-screen state before transitioning in */
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.setAttribute('open', '');
        });
      });
      this.dispatchEvent(new CustomEvent('drawer:open'));
    }
    close() {
      this.removeAttribute('open');
      document.documentElement.style.overflow = '';
      /* Wait for the slide-out transition, then hide from the DOM */
      var self = this;
      var content = this._content;
      if (content) {
        content.addEventListener('transitionend', function handler() {
          content.removeEventListener('transitionend', handler);
          self.setAttribute('hidden', '');
        });
        /* Safety fallback in case transitionend doesn't fire */
        setTimeout(function() { if (!self.hasAttribute('hidden')) self.setAttribute('hidden', ''); }, 400);
      } else {
        this.setAttribute('hidden', '');
      }
      this.dispatchEvent(new CustomEvent('drawer:close'));
    }
  }
  customElements.define('drawer-component', DrawerComponent);
}

/* --- Drawer Opener --- */
if (!customElements.get('drawer-opener')) {
  class DrawerOpener extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button') || this;
      var sel = this.getAttribute('data-drawer');
      btn.addEventListener('click', function() {
        var drawer = document.querySelector(sel);
        if (drawer && drawer.open) drawer.open();
      });
    }
  }
  customElements.define('drawer-opener', DrawerOpener);
}

/* --- Collapsible Tab --- */
if (!customElements.get('collapsible-tab')) {
  class CollapsibleTab extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-trigger]');
      this.content = this.querySelector('[data-content]');
      if (this.getAttribute('data-destroy') === 'true') {
        if (this.content) this.content.removeAttribute('hidden');
        return;
      }
      if (this.trigger) {
        this.trigger.addEventListener('click', () => this.toggle());
      }
      if (this.hasAttribute('open') && this.content) {
        this.content.removeAttribute('hidden');
      }
    }
    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.openTab();
      }
    }
    openTab() {
      this.setAttribute('open', 'true');
      if (this.content) this.content.removeAttribute('hidden');
    }
    close() {
      this.removeAttribute('open');
      if (this.content) this.content.setAttribute('hidden', '');
    }
  }
  customElements.define('collapsible-tab', CollapsibleTab);
}

/* --- AJAX page renderer for facet filtering --- */
if (typeof renderCollectionPage === 'undefined') {
  window.renderCollectionPage = function renderCollectionPage(url) {
    var container = document.getElementById('ProductGridContainer');
    if (container) container.classList.add('loading');

    return fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newContainer = doc.getElementById('ProductGridContainer');
        if (newContainer && container) {
          container.innerHTML = newContainer.innerHTML;
        }

        var newDrawer = doc.getElementById('Drawer-Facets');
        var oldDrawer = document.getElementById('Drawer-Facets');
        if (newDrawer && oldDrawer) {
          oldDrawer.innerHTML = newDrawer.innerHTML;
          /* Re-bind overlay & close-button listeners lost by innerHTML swap */
          if (oldDrawer._bindListeners) oldDrawer._bindListeners();
        }

        var newCounts = doc.querySelectorAll('[data-product-count]');
        var oldCounts = document.querySelectorAll('[data-product-count]');
        newCounts.forEach(function(el, i) {
          if (oldCounts[i]) oldCounts[i].innerHTML = el.innerHTML;
        });

        history.pushState({}, '', url);

        if (container) container.classList.remove('loading');
      })
      .catch(function() {
        window.location.href = url;
      });
  };
}

/* --- Sort By Dropdown --- */
if (!customElements.get('sort-by-dropdown')) {
  class SortByDropdown extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.pgrid-sort__trigger');
      this.menu = this.querySelector('.pgrid-sort__menu');
      this.hiddenInput = this.closest('form').querySelector('input[name="sort_by"]');
      this.valueLabel = this.querySelector('[data-sort-value]');

      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggle();
        });
      }

      if (this.menu) {
        this.menu.querySelectorAll('.pgrid-sort__option').forEach((opt) => {
          opt.addEventListener('click', () => this.select(opt));
        });
      }

      this._onClickOutside = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      document.addEventListener('click', this._onClickOutside);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onClickOutside);
    }

    toggle() {
      if (this.menu.hidden) { this.open(); } else { this.close(); }
    }

    open() {
      this.menu.hidden = false;
      this.trigger.setAttribute('aria-expanded', 'true');
      this.setAttribute('open', '');
    }

    close() {
      this.menu.hidden = true;
      this.trigger.setAttribute('aria-expanded', 'false');
      this.removeAttribute('open');
    }

    select(opt) {
      var value = opt.getAttribute('data-value');
      var label = opt.querySelector('span').textContent.trim();

      if (this.hiddenInput) this.hiddenInput.value = value;
      if (this.valueLabel) this.valueLabel.textContent = label;

      this.menu.querySelectorAll('.pgrid-sort__option').forEach(function(o) {
        o.classList.remove('pgrid-sort__option--active');
        o.removeAttribute('aria-selected');
        var check = o.querySelector('.pgrid-sort__check');
        if (check) check.remove();
      });
      opt.classList.add('pgrid-sort__option--active');
      opt.setAttribute('aria-selected', 'true');
      opt.insertAdjacentHTML('beforeend',
        '<svg class="pgrid-sort__check" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M3 8.5L6.5 12L13 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      );

      this.close();

      var form = this.closest('form');
      if (form) {
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  customElements.define('sort-by-dropdown', SortByDropdown);
}

/* --- Facet Filters Form --- */
if (!customElements.get('facet-filters-form')) {
  class FacetFiltersForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', function(e) { e.preventDefault(); });
      var isDrawerForm = this.form.hasAttribute('data-facet-form');
      if (!isDrawerForm) {
        this.form.addEventListener('change', this.onFormChange.bind(this));
      }
    }
    onFormChange() {
      var formData = new FormData(this.form);
      var params = new URLSearchParams(formData);
      var cleanParams = new URLSearchParams();
      params.forEach(function(value, key) {
        if (value !== '' && value !== undefined) {
          cleanParams.append(key, value);
        }
      });
      var url = window.location.pathname + '?' + cleanParams.toString();
      renderCollectionPage(url);
    }
  }
  customElements.define('facet-filters-form', FacetFiltersForm);
}

/* --- Facet Remove --- */
if (!customElements.get('facet-remove')) {
  class FacetRemove extends HTMLElement {
    connectedCallback() {
      var self = this;
      var link = this.querySelector('a');
      if (!link) return;
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var drawer = self.closest('drawer-component');
        if (drawer && drawer.close) drawer.close();
        renderCollectionPage(link.getAttribute('href'));
      });
    }
  }
  customElements.define('facet-remove', FacetRemove);
}

/* --- Facet Apply (drawer mode) --- */
if (!customElements.get('facet-apply')) {
  class FacetApply extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var form = document.querySelector('[data-facet-form]');
        if (!form) return;
        var formData = new FormData(form);
        var params = new URLSearchParams();
        formData.forEach(function(value, key) {
          if (value !== '' && value !== undefined) {
            params.append(key, value);
          }
        });
        var drawer = this.closest('drawer-component');
        if (drawer && drawer.close) drawer.close();
        var url = window.location.pathname + '?' + params.toString();
        renderCollectionPage(url);
      }.bind(this));
    }
  }
  customElements.define('facet-apply', FacetApply);
}

/* --- Price Range --- */
if (!customElements.get('price-range')) {
  class PriceRange extends HTMLElement {
    connectedCallback() {
      this.minRange = this.querySelector('[data-type="min-range"]');
      this.maxRange = this.querySelector('[data-type="max-range"]');
      this.minInput = this.querySelector('[data-type="min-input"]');
      this.maxInput = this.querySelector('[data-type="max-input"]');
      var priceMax = parseFloat(this.getAttribute('data-price-max')) || 1000;
      var gap = parseFloat(this.getAttribute('data-price-gap')) || 5;
      var self = this;

      function updateSlider() {
        var minVal = parseFloat(self.minRange.value) || 0;
        var maxVal = parseFloat(self.maxRange.value) || priceMax;
        if (maxVal - minVal < gap) {
          if (this === self.minRange) {
            self.minRange.value = maxVal - gap;
            minVal = maxVal - gap;
          } else {
            self.maxRange.value = minVal + gap;
            maxVal = minVal + gap;
          }
        }
        self.style.setProperty('--price-min', (minVal / priceMax * 100) + '%');
        self.style.setProperty('--price-max', (maxVal / priceMax * 100) + '%');
        if (self.minInput) self.minInput.value = minVal;
        if (self.maxInput) self.maxInput.value = maxVal;
      }

      function updateFromInput() {
        var minVal = parseFloat(self.minInput.value) || 0;
        var maxVal = parseFloat(self.maxInput.value) || priceMax;
        if (self.minRange) self.minRange.value = minVal;
        if (self.maxRange) self.maxRange.value = maxVal;
        self.style.setProperty('--price-min', (minVal / priceMax * 100) + '%');
        self.style.setProperty('--price-max', (maxVal / priceMax * 100) + '%');
      }

      if (this.minRange) this.minRange.addEventListener('input', updateSlider);
      if (this.maxRange) this.maxRange.addEventListener('input', updateSlider);
      if (this.minInput) this.minInput.addEventListener('change', updateFromInput);
      if (this.maxInput) this.maxInput.addEventListener('change', updateFromInput);
    }
  }
  customElements.define('price-range', PriceRange);
}

/* --- Show More Button --- */
if (!customElements.get('show-more-button')) {
  class ShowMoreButton extends HTMLElement {
    connectedCallback() {
      var btn = this.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function() {
        var facetBlock = this.closest('.f-facets__block') || this.closest('.js-filter');
        if (!facetBlock) return;
        var hiddenItems = facetBlock.querySelectorAll('.show-more-item');
        var labelMore = btn.querySelector('.label-show-more');
        var labelLess = btn.querySelector('.label-show-less');
        var isExpanded = labelMore && labelMore.classList.contains('hidden');

        hiddenItems.forEach(function(item) {
          if (isExpanded) {
            item.classList.add('hidden');
          } else {
            item.classList.remove('hidden');
          }
        });

        if (labelMore && labelLess) {
          labelMore.classList.toggle('hidden');
          labelLess.classList.toggle('hidden');
        }
      }.bind(this));
    }
  }
  customElements.define('show-more-button', ShowMoreButton);
}

/* --- Product Grid Container (pass-through) --- */
if (!customElements.get('product-grid-container')) {
  class ProductGridContainer extends HTMLElement {}
  customElements.define('product-grid-container', ProductGridContainer);
}

/* --- Motion Element (pass-through) --- */
if (!customElements.get('motion-element')) {
  class MotionElement extends HTMLElement {}
  customElements.define('motion-element', MotionElement);
}

/* --- Filter Color Swatch (pass-through) --- */
if (!customElements.get('filter-color-swatch')) {
  class FilterColorSwatch extends HTMLElement {}
  customElements.define('filter-color-swatch', FilterColorSwatch);
}

/* --- Product Form (pass-through for product card quick-add) --- */
if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {}
  customElements.define('product-form', ProductForm);
}

/* --- Handle browser back/forward for AJAX filtering --- */
window.addEventListener('popstate', function() {
  renderCollectionPage(window.location.href);
});

/* --- Sticky filter bar: measure header height --- */
(function() {
  function setStickyTop() {
    var header = document.querySelector('.f-section-header, .shopify-section-header, header');
    var top = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--sticky-filter-top', top + 'px');
  }
  setStickyTop();
  window.addEventListener('resize', setStickyTop);
})();

/* --- Column Switcher for mobile --- */
(function() {
  var container = document.querySelector('[data-column-switcher]');
  if (!container) return;
  var buttons = container.querySelectorAll('[data-column]');
  var grid = document.querySelector('[data-products-grid]');
  if (!buttons.length || !grid) return;

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var cols = this.getAttribute('data-column');
      buttons.forEach(function(b) {
        b.classList.remove('pgrid-col-switcher__btn--active');
        b.setAttribute('aria-pressed', 'false');
      });
      this.classList.add('pgrid-col-switcher__btn--active');
      this.setAttribute('aria-pressed', 'true');
      grid.setAttribute('data-mobile-columns', cols);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Fetch recently viewed products from localStorage */
  var sections = document.querySelectorAll('[data-section-type="product-recently-viewed"]');
  sections.forEach(function(section) {
    var container = section.querySelector('[data-url]');
    if (!container) return;
    var baseUrl = container.dataset.url;
    if (!baseUrl) return;

    var key = 'recently-viewed';
    var items = [];
    try { items = JSON.parse(localStorage.getItem(key) || '[]'); } catch (e) { return; }
    if (items.length === 0) { section.style.display = 'none'; return; }

    var query = items.map(function(id) { return 'id:' + id; }).join(' OR ');
    var url = baseUrl + encodeURIComponent(query);

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('[data-section-type="product-recently-viewed"] [data-url]');
        if (source && source.innerHTML.trim()) {
          container.innerHTML = source.innerHTML;
          initSlider(section);
        } else {
          section.style.display = 'none';
        }
      })
      .catch(function() {});
  });

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-section-type="product-recently-viewed"]');
    if (section) initSlider(section);
  });

  function initSlider(section) {
    var slider = section.querySelector('[data-product-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;

    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dotsContainer = section.querySelector('[data-slider-dots]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 4;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (slideWidth === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap));
      if (slidesPerView === 0) slidesPerView = 1;
      var totalDots = Math.ceil(slides.length / slidesPerView);

      if (totalDots <= 1) { dotsContainer.style.display = 'none'; return; }
      dotsContainer.style.display = '';

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'recently-viewed__dot' + (i === 0 ? ' recently-viewed__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.dataset.dotIndex = i;
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.dotIndex);
          var spv = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
          slider.scrollTo({ left: idx * spv * (slideWidth + gap), behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.recently-viewed__dot');
      if (dots.length === 0) return;
      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
      var currentGroup = Math.round(slider.scrollLeft / (slidesPerView * (slideWidth + gap)));
      dots.forEach(function(dot, i) {
        dot.classList.toggle('recently-viewed__dot--active', i === currentGroup);
      });
    }

    function update() {
      measure();
      updateNavState();
      createDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateNavState();
        updateDots();
      }, 50);
    });

    /* Drag to scroll (desktop mouse) */
    var isMouseDown = false;
    var hasDragged = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    /* Prevent native image/link drag from hijacking mouse events */
    slider.addEventListener('dragstart', function(e) { e.preventDefault(); });

    slider.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth) return;
      isMouseDown = true;
      hasDragged = false;
      dragStartX = e.pageX;
      dragStartScrollLeft = slider.scrollLeft;
    });

    document.addEventListener('mousemove', function(e) {
      if (!isMouseDown) return;
      var dx = e.pageX - dragStartX;
      if (!hasDragged && Math.abs(dx) > 5) {
        hasDragged = true;
        slider.classList.add('is-dragging');
      }
      if (hasDragged) {
        e.preventDefault();
        slider.scrollLeft = dragStartScrollLeft - dx;
      }
    });

    var endDrag = function() {
      if (!isMouseDown) return;
      isMouseDown = false;
      slider.classList.remove('is-dragging');
      setTimeout(function() { hasDragged = false; }, 0);
    };

    document.addEventListener('mouseup', endDrag);
    window.addEventListener('blur', endDrag);

    slider.addEventListener('click', function(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    var resizeObserver = new ResizeObserver(function() { update(); });
    resizeObserver.observe(slider);

    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
(function() {
  /* Fetch recommendations via section rendering API */
  var sections = document.querySelectorAll('[data-section-type="product-recommendations"]');
  sections.forEach(function(section) {
    var container = section.querySelector('[data-url]');
    if (!container) return;
    var url = container.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var source = doc.querySelector('[data-section-type="product-recommendations"] [data-url]');
        if (source && source.innerHTML.trim()) {
          container.innerHTML = source.innerHTML;
          initSlider(section);
        }
      })
      .catch(function() {});
  });

  /* Re-init on Shopify section events */
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-section-type="product-recommendations"]');
    if (section) initSlider(section);
  });

  function initSlider(section) {
    var slider = section.querySelector('[data-product-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;

    var prevBtn = section.querySelector('[data-slider-prev]');
    var nextBtn = section.querySelector('[data-slider-next]');
    var dotsContainer = section.querySelector('[data-slider-dots]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 4;
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      if (slideWidth === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap));
      if (slidesPerView === 0) slidesPerView = 1;
      var totalDots = Math.ceil(slides.length / slidesPerView);

      if (totalDots <= 1) { dotsContainer.style.display = 'none'; return; }
      dotsContainer.style.display = '';

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'product-recs__dot' + (i === 0 ? ' product-recs__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.dataset.dotIndex = i;
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.dotIndex);
          var spv = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
          slider.scrollTo({ left: idx * spv * (slideWidth + gap), behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.product-recs__dot');
      if (dots.length === 0) return;
      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
      var currentGroup = Math.round(slider.scrollLeft / (slidesPerView * (slideWidth + gap)));
      dots.forEach(function(dot, i) {
        dot.classList.toggle('product-recs__dot--active', i === currentGroup);
      });
    }

    function update() {
      measure();
      updateNavState();
      createDots();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateNavState();
        updateDots();
      }, 50);
    });

    /* Drag to scroll (desktop mouse) */
    var isMouseDown = false;
    var hasDragged = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;

    /* Prevent native image/link drag from hijacking mouse events */
    slider.addEventListener('dragstart', function(e) { e.preventDefault(); });

    slider.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      if (slider.scrollWidth <= slider.clientWidth) return;
      isMouseDown = true;
      hasDragged = false;
      dragStartX = e.pageX;
      dragStartScrollLeft = slider.scrollLeft;
    });

    document.addEventListener('mousemove', function(e) {
      if (!isMouseDown) return;
      var dx = e.pageX - dragStartX;
      if (!hasDragged && Math.abs(dx) > 5) {
        hasDragged = true;
        slider.classList.add('is-dragging');
      }
      if (hasDragged) {
        e.preventDefault();
        slider.scrollLeft = dragStartScrollLeft - dx;
      }
    });

    var endDrag = function() {
      if (!isMouseDown) return;
      isMouseDown = false;
      slider.classList.remove('is-dragging');
      setTimeout(function() { hasDragged = false; }, 0);
    };

    document.addEventListener('mouseup', endDrag);
    window.addEventListener('blur', endDrag);

    slider.addEventListener('click', function(e) {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    var resizeObserver = new ResizeObserver(function() { update(); });
    resizeObserver.observe(slider);

    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
/* Product Tabs - Tab switching and slider */
(function() {
  var sections = document.querySelectorAll('[data-section-type="product-tabs"]');

  sections.forEach(function(section) {
    initSection(section);
  });

  /* Re-init on Shopify section events */
  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-section-type="product-tabs"]');
    if (section) initSection(section);
  });

  function initSection(section) {
    initTabs(section);
    var panels = section.querySelectorAll('[data-tab-panel]');
    panels.forEach(function(panel) {
      initSlider(panel);
    });
  }

  /* Tab switching */
  function initTabs(section) {
    var tabs = section.querySelectorAll('[data-tab-trigger]');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var targetId = tab.getAttribute('data-tab-trigger');

        /* Deactivate all tabs */
        tabs.forEach(function(t) {
          t.classList.remove('product-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });

        /* Hide all panels */
        var panels = section.querySelectorAll('[data-tab-panel]');
        panels.forEach(function(p) {
          p.setAttribute('hidden', '');
        });

        /* Activate clicked tab */
        tab.classList.add('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'true');

        /* Show target panel */
        var targetPanel = section.querySelector('[data-tab-panel="' + targetId + '"]');
        if (targetPanel) {
          targetPanel.removeAttribute('hidden');
          /* Re-init slider for newly visible panel */
          initSlider(targetPanel);
        }
      });
    });

    /* Keyboard navigation for tabs */
    var tabList = section.querySelector('[role="tablist"]');
    if (tabList) {
      tabList.addEventListener('keydown', function(e) {
        var tabsArr = Array.from(tabs);
        var index = tabsArr.indexOf(document.activeElement);
        if (index === -1) return;

        var newIndex;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          newIndex = (index + 1) % tabsArr.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          newIndex = (index - 1 + tabsArr.length) % tabsArr.length;
        } else if (e.key === 'Home') {
          e.preventDefault();
          newIndex = 0;
        } else if (e.key === 'End') {
          e.preventDefault();
          newIndex = tabsArr.length - 1;
        }

        if (newIndex !== undefined) {
          tabsArr[newIndex].focus();
          tabsArr[newIndex].click();
        }
      });
    }
  }

  /* Slider functionality */
  function initSlider(panel) {
    var slider = panel.querySelector('[data-product-slider]');
    if (!slider) return;

    var slides = slider.querySelectorAll('[data-slide]');
    if (slides.length === 0) return;

    /* Only bind events once per panel */
    if (slider._sliderInit) {
      /* Just recalc measurements and rebuild dots */
      slider._sliderUpdate();
      return;
    }

    var prevBtn = panel.querySelector('[data-slider-prev]');
    var nextBtn = panel.querySelector('[data-slider-next]');
    var dotsContainer = panel.querySelector('[data-slider-dots]');

    var slideWidth = 0;
    var gap = 0;

    function measure() {
      slideWidth = slides[0].offsetWidth;
      gap = parseFloat(getComputedStyle(slider).columnGap) || 4;
    }

    /* Update nav button states */
    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(slider.scrollLeft);
      var maxScroll = slider.scrollWidth - slider.clientWidth;

      prevBtn.disabled = scrollLeft <= 1;
      nextBtn.disabled = scrollLeft >= maxScroll - 1;
    }

    /* Create dots */
    function createDots() {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';

      if (slideWidth === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap));
      if (slidesPerView === 0) slidesPerView = 1;
      var totalDots = Math.ceil(slides.length / slidesPerView);

      if (totalDots <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = '';

      for (var i = 0; i < totalDots; i++) {
        var dot = document.createElement('button');
        dot.className = 'product-tabs__dot' + (i === 0 ? ' product-tabs__dot--active' : '');
        dot.setAttribute('aria-label', 'Go to slide group ' + (i + 1));
        dot.dataset.dotIndex = i;
        dot.addEventListener('click', function() {
          var idx = parseInt(this.dataset.dotIndex);
          var spv = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
          var scrollTarget = idx * spv * (slideWidth + gap);
          slider.scrollTo({ left: scrollTarget, behavior: 'smooth' });
        });
        dotsContainer.appendChild(dot);
      }
    }

    /* Update active dot */
    function updateDots() {
      if (!dotsContainer) return;
      var dots = dotsContainer.querySelectorAll('.product-tabs__dot');
      if (dots.length === 0) return;

      var slidesPerView = Math.round(slider.clientWidth / (slideWidth + gap)) || 1;
      var currentGroup = Math.round(slider.scrollLeft / (slidesPerView * (slideWidth + gap)));

      dots.forEach(function(dot, i) {
        dot.classList.toggle('product-tabs__dot--active', i === currentGroup);
      });
    }

    function update() {
      measure();
      updateNavState();
      createDots();
    }

    /* Prev/Next handlers */
    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        slider.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        slider.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
      });
    }

    /* Scroll listener */
    var scrollTimeout;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        updateNavState();
        updateDots();
      }, 50);
    });

    /* Recalc on resize */
    var resizeObserver = new ResizeObserver(function() {
      update();
    });
    resizeObserver.observe(slider);

    /* Mark as initialized and expose update */
    slider._sliderInit = true;
    slider._sliderUpdate = update;

    /* Initial calc */
    update();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
class SlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.isHovered = false;
    this.isFocused = false;
  }

  connectedCallback() {
    this.slides = this.querySelectorAll('[data-slide-index]');
    this.dots = this.querySelectorAll('[data-slide-to]');
    this.counterEl = this.querySelector('[data-current-slide]');
    this.slideCount = this.slides.length;

    if (this.slideCount <= 1) return;

    this.prevBtn = this.querySelector('[data-action="prev"]');
    this.nextBtn = this.querySelector('[data-action="next"]');

    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        var index = parseInt(dot.getAttribute('data-slide-to'), 10);
        this.goTo(index);
      });
    });

    this.addEventListener('mouseenter', () => { this.isHovered = true; this.pauseAutoplay(); });
    this.addEventListener('mouseleave', () => { this.isHovered = false; this.resumeAutoplay(); });
    this.addEventListener('focusin', () => { this.isFocused = true; this.pauseAutoplay(); });
    this.addEventListener('focusout', () => { this.isFocused = false; this.resumeAutoplay(); });

    if (this.getAttribute('data-autoplay') === 'true') {
      this.startAutoplay();
    }

    this.activateVideo(0);
  }

  disconnectedCallback() {
    this.pauseAutoplay();
  }

  goTo(index) {
    if (index === this.currentIndex || index < 0 || index >= this.slideCount) return;

    var prevSlide = this.slides[this.currentIndex];
    var nextSlide = this.slides[index];

    prevSlide.classList.remove('slideshow__slide--active');
    nextSlide.classList.add('slideshow__slide--active');

    this.deactivateVideo(this.currentIndex);
    this.activateVideo(index);

    this.dots.forEach(function(dot, i) {
      dot.classList.toggle('slideshow__dot--active', i === index);
      dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });

    if (this.counterEl) {
      this.counterEl.textContent = index + 1;
    }

    this.currentIndex = index;
  }

  next() {
    var nextIndex = (this.currentIndex + 1) % this.slideCount;
    this.goTo(nextIndex);
  }

  prev() {
    var prevIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
    this.goTo(prevIndex);
  }

  startAutoplay() {
    var speed = parseInt(this.getAttribute('data-speed'), 10) || 3;
    this.autoplayInterval = setInterval(function() { this.next(); }.bind(this), speed * 1000);
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  resumeAutoplay() {
    if (this.isHovered || this.isFocused) return;
    if (this.getAttribute('data-autoplay') === 'true') {
      this.startAutoplay();
    }
  }

  activateVideo(index) {
    var slide = this.slides[index];
    if (!slide) return;
    var template = slide.querySelector('template[data-video]');
    if (!template) return;
    var container = template.parentElement;
    if (container.querySelector('video')) return;
    var clone = template.content.cloneNode(true);
    container.appendChild(clone);
  }

  deactivateVideo(index) {
    var slide = this.slides[index];
    if (!slide) return;
    var video = slide.querySelector('video');
    if (video) {
      video.pause();
      video.remove();
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"]) return;
  try {
    
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.mainForm = null;
      this.mainButton = null;
      this.observer = null;
    }

    connectedCallback() {
      this.variantSelect = this.querySelector('[data-sticky-variant-select]');
      this.priceContainer = this.querySelector('[id^="StickyATCPrice"]');
      this.sizeProperty = this.querySelector('[data-sticky-size-property]');

      var self = this;
      var findButton = function() {
        self.mainButton = document.querySelector('.f-product-form__submit');
        if (self.mainButton) {
          self.setupObserver();
        } else {
          requestAnimationFrame(findButton);
        }
      };
      findButton();

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', this.onVariantChange.bind(this));
      }

      document.addEventListener('variant:changed', this.onMainVariantChange.bind(this));
      document.addEventListener('region:changed', this.onPdpUpdate.bind(this));
      document.addEventListener('size:selected', this.syncSizeProperty.bind(this));

      var sync = function() {
        self.syncLabelsFromPdp();
        self.syncSizeProperty();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', sync);
      } else {
        requestAnimationFrame(sync);
      }
    }

    onPdpUpdate() {
      this.syncLabelsFromPdp();
      this.syncSizeProperty();
    }

    syncLabelsFromPdp() {
      if (!this.variantSelect) return;
      var pdpRadios = document.querySelectorAll(
        'variant-picker input[type="radio"]'
      );
      if (!pdpRadios.length) return;

      var labelMap = {};
      pdpRadios.forEach(function(radio) {
        var btn = document.querySelector('label[for="' + radio.id + '"]');
        if (btn && btn.classList.contains('variant-picker__option-button--button')) {
          labelMap[radio.value] = btn.textContent.trim();
        }
      });

      var soldText = this.dataset.soldText || 'Sold out';
      this.variantSelect.querySelectorAll('option[data-au-size]').forEach(function(opt) {
        var formatted = labelMap[opt.dataset.auSize] || opt.dataset.auSize;
        opt.textContent = opt.disabled ? formatted + ' - ' + soldText : formatted;
      });
    }

    syncSizeProperty() {
      if (!this.sizeProperty) return;
      var pdpProperty = document.querySelector('[data-size-property]');
      if (!pdpProperty) return;
      this.sizeProperty.value = pdpProperty.value;
      this.sizeProperty.disabled = pdpProperty.disabled;
    }

    setupObserver() {
      if (!this.mainButton) return;

      var self = this;
      this.observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              self.removeAttribute('open');
            } else {
              self.removeAttribute('hidden');
              self.setAttribute('open', '');
            }
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );

      this.observer.observe(this.mainButton);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }

    onVariantChange(event) {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const variantId = selectedOption.value;

      const stickyForm = this.querySelector('input[name="id"]');
      if (stickyForm) {
        stickyForm.value = variantId;
      }

      this.updatePrice(selectedOption);
      this.updateButton(!selectedOption.disabled);

      /* Sync PDP size picker by AU size value */
      const auSize = selectedOption.dataset.auSize;
      if (!auSize) return;
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;
      const radio = variantPicker.querySelector(
        '.variant-picker__field input[type="radio"][value="' + CSS.escape(auSize) + '"]'
      );
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    onMainVariantChange(event) {
      const variant = event.detail;
      if (!variant) return;

      if (this.variantSelect) {
        this.variantSelect.value = variant.id;
      }

      const stickyForm = this.querySelector('input[name="id"]');
      if (stickyForm) {
        stickyForm.value = variant.id;
      }

      this.updateButton(variant.available);
      this.syncSizeProperty();
    }

    updatePrice(option) {
      if (!this.priceContainer) return;
      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice;

      if (comparePrice) {
        this.priceContainer.innerHTML =
          '<span class="sticky-atc__price-sale">' + price + '</span>' +
          '<s class="sticky-atc__price-compare">' + comparePrice + '</s>';
      } else {
        this.priceContainer.innerHTML = '<span>' + price + '</span>';
      }
    }

    updateButton(available) {
      const button = this.querySelector('.sticky-atc__button');
      if (!button) return;
      button.disabled = !available;
      const span = button.querySelector('span');
      if (span) {
        span.textContent = available
          ? button.closest('sticky-add-to-cart').dataset.addText || 'Add to bag'
          : button.closest('sticky-add-to-cart').dataset.soldText || 'Sold out';
      }
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initVideo(section) {
    var medias = section.querySelectorAll('.vid__media');
    medias.forEach(function(media) {
      var posterBtn = media.querySelector('.vid__poster-button');
      var template = media.querySelector('template');
      if (!posterBtn || !template) return;
      if (media._vidInit) return;
      media._vidInit = true;

      posterBtn.addEventListener('click', function() {
        var content = template.content.cloneNode(true);
        media.appendChild(content);
        posterBtn.style.display = 'none';
      });
    });
  }

  document.querySelectorAll('.vid').forEach(initVideo);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('.vid');
    if (section) initVideo(section);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
